export const zhCN = {
  common: {
    nav: {
      overview: "总览",
      account: "我的身份",
      apps: "应用与授权",
      security: "安全中心",
      admin: "租户管理",
      platform: "平台控制台",
      settings: "系统设置",
      docs: "对接文档",
      developer: "开发者控制台",
      support: "工单",
      announcements: "公告",
      withdrawal: "提现",
    },
    buttons: {
      save: "保存",
      cancel: "取消",
      delete: "删除",
      confirm: "确认",
      retry: "重试",
      logout: "退出登录",
      savePreferences: "保存偏好",
      saveSettings: "保存界面设置",
    },
  },
  auth: {
    loginTitle: "登录你的工作区",
    loginSubtitle: "使用租户账号进入 OwO! Identity。",
    tenant: "租户标识",
    login: "用户名或邮箱",
    password: "密码",
    submit: "登录",
    forgotPassword: "忘记密码",
    mfaTitle: "二次验证",
    backToLogin: "返回登录",
  },
  settings: {
    eyebrow: "账号偏好",
    title: "界面设置",
    description: "这些选项随账号保存，登录后在其他浏览器同样生效。",
    language: "界面语言",
    languageHint: "切换后立即生效",
    compact: "紧凑数据表",
    compactHint: "在同一屏幕显示更多记录",
    reducedMotion: "降低动态效果",
    reducedMotionHint: "减少非必要的状态过渡",
    theme: "外观主题",
    themeHint: "浅色、深色或跟随系统，随账号同步",
    themeLight: "浅色",
    themeDark: "深色",
    themeSystem: "跟随系统",
    saved: "界面设置已保存",
    saveFailed: "保存失败",
  },
  account: {
    preferencesTitle: "界面与通知",
    preferencesHint: "偏好只影响你的账号，不改变租户策略。",
    locale: "语言",
    timezone: "时区",
    saved: "偏好已保存",
    saveFailed: "保存失败",
    loading: "正在读取偏好",
    loadFailed: "无法读取偏好",
    eyebrow: "个人身份",
    title: "Profile 与设置",
    description: "维护别人看到的身份资料，以及与你的账号关联的信息。",
    export: "导出我的数据",
    profileTab: "基本资料",
    emailsTab: "邮箱地址",
    addressesTab: "地址",
    preferencesTab: "偏好设置",
    billingTab: "支付方式",
    publicTitle: "公开资料",
    publicHint: "这些信息会出现在应用授权和管理员目录中。",
    username: "用户名",
    displayName: "显示名称",
    phone: "手机号",
    avatar: "头像 URL",
    gender: "性别",
    genderUnset: "未填写",
    genderFemale: "女",
    genderMale: "男",
    genderUnspecified: "不便说明",
    birthday: "生日",
    avatarUpload: "上传头像",
    avatarUploadOk: "头像已上传",
    avatarUploadFailed: "无法上传头像",
    avatarClear: "移除上传的头像",
    avatarChoiceTitle: "选择使用哪张头像",
    avatarChoiceLead: "头像网址和上传的图片都在。请选择默认显示哪一张。",
    avatarChoiceUrl: "使用网址",
    avatarChoiceUpload: "使用上传的头像",
    avatarChoiceUploadHint: "保存在本平台的图片",
    avatarChoiceFallback: "加载失败时改用另一张",
    avatarChoiceFallbackHint: "只在你选择的头像打不开时才显示另一张。",
    avatarChoiceSave: "使用这张",
    avatarChoiceLater: "稍后决定",
    saveProfile: "保存资料",
    profileSaved: "资料已保存",
    loadingProfile: "正在读取资料",
    emailsTitle: "邮箱地址",
    emailsHint: "主邮箱用于登录、安全通知和账号恢复。",
    addEmail: "添加邮箱",
    addEmailTitle: "添加邮箱",
    emailAddress: "邮箱地址",
    addAndVerify: "添加并验证",
    emailAdded: "邮箱已添加，验证邮件已发出",
    codeSent: "验证邮件已发送。邮件使用系统模板，验证码在正文里，也可以点邮件中的按钮。",
    codePlaceholder: "输入验证码",
    confirmCode: "确认验证码",
    codeVerified: "邮箱已验证",
    codeInvalid: "验证码不正确或已过期",
    emailDeliveryFailed: "邮箱已保存，但验证邮件没有发出。请稍后点重新发送。",
    addFailed: "添加失败",
    primaryEmail: "主邮箱",
    secondaryEmail: "辅助邮箱",
    verified: "已验证",
    unverified: "待验证",
    resend: "重新发送验证",
    resendWait: "请等待 {seconds} 秒后再发送验证邮件。",
    verificationSent: "验证邮件已发送",
    verificationFailed: "验证邮件发送失败",
    emailsLoadFailed: "无法读取邮箱",
    emailsEmpty: "尚未添加邮箱",
    removeEmail: "移除邮箱",
    cannotRemovePrimary: "无法移除唯一主邮箱",
    mustAddAnother: "必须先添加另一个邮箱",
    removeEmailConfirm: "确认移除",
    removeEmailBody: "移除后，该邮箱将不再用于此账号的通知与恢复。",
    emailRemoved: "邮箱已移除",
    emailRemoveFailed: "邮箱移除失败",
    addressesTitle: "地址簿",
    addressesHint: "保存常用地址，供已获授权的业务应用使用；保存时会校验国家与邮编目录。",
    addAddress: "添加地址",
    editAddress: "编辑地址",
    label: "标签",
    labelPlaceholder: "家庭、办公室",
    country: "国家代码",
    line1: "地址",
    line2: "地址补充",
    city: "城市",
    postalCode: "邮编",
    region: "州/省",
    defaultAddress: "默认",
    ordinaryAddress: "普通",
    saveAddress: "保存地址",
    addressAdded: "地址已添加",
    addressUpdated: "地址已更新",
    updateFailed: "更新失败",
    addressesLoadFailed: "无法读取地址",
    addressesEmpty: "尚未添加地址",
    fallbackAddress: "常用地址",
    removeAddress: "移除地址",
    removeAddressBody: "移除后，已授权应用将无法再读取这个地址。",
    addressRemoved: "地址已移除",
    addressRemoveFailed: "地址移除失败",
    notifyTitle: "安全通知",
    notifyHint: "这些开关只决定是否通知你，不改变租户的安全策略。",
    notifyLogin: "登录异常",
    notifyLoginHint: "新地点或新设备登录时通知",
    notifyAdmin: "管理员操作",
    notifyAdminHint: "密码重置、停用或角色变更时通知",
    billingTitle: "支付方式",
    billingHint: "支付服务尚未启用。OwO! Identity 当前不会收集或保存银行卡信息。",
    billingEmpty: "没有支付方式",
    billingEmptyHint: "当租户启用支付服务后，可在这里管理账单方式。",
    addPayment: "添加支付方式",
  },
  dashboard: {
    greetingMorning: "早上好",
    greetingAfternoon: "下午好",
    greetingEvening: "晚上好",
    verifiedIdentity: "已验证身份",
    scope: "权限范围",
    scopePlatform: "平台",
    scopeTenant: "租户管理",
    scopeMember: "个人",
    currentTenant: "当前租户",
    sessionReady: "已登录",
    sessionUnknown: "正在确认会话",
    eyebrow: "身份总览",
    summary: "这里汇总你的访问授权、登录保护与最近活动。",
    securityCheck: "安全检查",
    appsMetric: "可访问应用",
    appsMetricDetail: "当前租户目录",
    consentsMetric: "有效授权",
    consentsMetricDetail: "可随时撤销",
    quickAccess: "快速访问",
    yourApps: "你的应用",
    viewAll: "查看全部",
    unnamedApp: "未命名应用",
    authorizedApp: "已授权的工作应用",
    noAuthorizedApps: "当前还没有设置了应用主页的已授权应用。在 OIDC 应用里填写主页，并从该应用登录后会出现在这里。",
    openCatalog: "打开应用目录",
    protection: "登录保护",
    securityStatus: "安全状态",
    checklistEmail: "验证主邮箱",
    checklistMfa: "开启一种登录验证",
    checklistActivity: "查看近期登录活动",
    openSecurity: "打开安全中心",
    done: "已完成",
    todo: "待完成",
    layoutHint: "拖动卡片右上角的手柄。拖动时会出现网格，可以把卡片放到另一列的空位里，松手后自动保存。",
    layoutSaving: "正在保存布局…",
    layoutSaved: "总览布局已保存",
    layoutFailed: "无法保存总览布局",
    drag: "拖动调整顺序",
    widgetEyebrow: "总览组件",
    platformTitle: "平台运行",
    platformFailed: "无法读取平台运行情况",
    tenantCount: "租户",
    registeredUsers: "已注册用户",
    registeredCount: "{count} 人已注册",
    onlineCount: "{count} 人在线",
    auditTitle: "最近审计",
    tenantAudits: "租户审计",
    platformAudits: "平台审计",
    auditFailed: "无法读取审计",
    auditEmpty: "还没有审计记录",
    auditFailedEvent: "未成功",
    globeTitle: "在线位置",
    globeFailed: "无法读取在线位置",
    globeUnavailable: "本地地址库不可用，地球上暂时没有位置。",
    globeEmpty: "当前没有可定位的在线会话。",
    globeReset: "重置视角",
    unknownPlace: "未命名地区",
  },
  query: {
    loadFailed: "无法读取数据",
    empty: "暂无记录",
    refreshPage: "刷新页面",
    timeout: "请求超时，请稍后重试",
    network: "网络连接失败，请检查后重试",
    upstream: "身份服务暂时不可用，请稍后重试",
    csrf: "安全令牌已失效，请刷新页面后重试",
  },
  device: {
    title: "授权设备登录",
    subtitle: "输入设备显示的用户码，确认后该设备即可获取令牌。",
    userCode: "用户码",
    lookup: "查询请求",
    client: "客户端",
    status: "状态",
    expires: "过期时间",
    flow: "流程",
    flowDevice: "设备授权",
    flowCiba: "后台认证（CIBA）",
    bindingMessage: "绑定信息",
    loginHint: "目标账号",
    approve: "批准",
    deny: "拒绝",
    approved: "已批准登录",
    denied: "已拒绝登录",
    doneHint: "你可以关闭此页面，返回请求方继续操作。",
    backHome: "返回门户",
    missingFields: "请填写租户标识和用户码",
    verifyFailed: "无法校验用户码",
    actionFailed: "操作失败，请重试",
  },
  interact: {
    title: "授权应用访问",
    subtitle: "确认后，该应用将获得一次性授权码，并只能使用你同意的范围。",
    heading: "允许此应用访问你的身份？",
    intro: "请核对应用名称与请求范围。拒绝后应用不会获得令牌。",
    client: "客户端",
    workspace: "工作区",
    expires: "请求过期时间",
    scopes: "请求范围",
    approve: "允许并继续",
    deny: "拒绝",
    loading: "正在读取授权请求",
    missing: "缺少授权请求。请从应用重新登录。",
    loadFailed: "无法读取授权请求",
    actionFailed: "授权操作失败，请重试",
    redirectFailed: "无法返回应用，请重新发起登录",
  },
  apps: {
    eyebrow: "访问目录",
    title: "应用与授权",
    description: "打开租户提供的应用，并决定哪些应用可以继续访问你的身份信息。",
    availableTitle: "可用应用",
    availableHint: "由当前租户发布的 OIDC 应用。打开链接使用应用主页。",
    authorizedTitle: "已授权应用",
    authorizedHint: "可按范围撤销。撤销后，相关已跟踪 Token 将失效。",
    loadAppsFailed: "无法载入应用目录",
    noApps: "当前没有可用应用",
    noAppsAction: "到租户管理注册应用",
    defaultDescription: "使用 OwO! Identity 登录",
    openNew: "在新窗口打开 {name}",
    noLink: "{name} 尚未设置应用主页",
    noConsents: "尚未授权应用。从应用发起登录并同意后会出现在这里。",
    openSecurity: "查看安全中心",
    lastUsed: "最近使用",
    neverUsed: "尚未使用",
    highRisk: "高风险范围",
    revoke: "撤销",
    revokeScope: "撤销此范围",
    revokeAllTitle: "撤销应用授权？",
    revokeAllBody: "该应用的全部范围与相关 Token 将失效。",
    revokeScopeTitle: "撤销该范围？",
    revokeScopeBody: "仅移除所选范围；其余范围仍有效，相关 Token 会立即失效。",
    revoked: "应用授权已撤销",
    scopeRevoked: "范围已撤销",
    revokeFailed: "撤销失败",
    confirm: "撤销授权",
    cancel: "取消",
  },
  notices: {
    tab: "通知",
    title: "安全通知",
    hint: "这里只显示已经发生的安全事件。退订后，同类事件不再投递。",
    empty: "还没有安全通知。",
    open: "打开通知",
    unread: "{count} 条未读通知",
    markRead: "标为已读",
    markAll: "全部标为已读",
    unsubscribe: "退订这类通知",
    unsubscribed: "已退订这类通知",
    unsubscribeFailed: "无法退订",
    loadFailed: "无法读取通知",
    newDevice: "新设备登录：{device}",
    passwordChanged: "密码已修改",
    passwordReset: "密码已通过重置链接更新",
    passwordResetByAdmin: "管理员重置了你的密码",
    policyChanged: "租户安全策略已调整",
    developerSubmitted: "{applicant} 提交了开发者申请",
    developerApproved: "你的开发者申请已通过",
    developerRejected: "你的开发者申请未通过",
    developerRejectedReason: "你的开发者申请未通过：{reason}",
    developerRevoked: "你的开发者权限已收回",
    developerRevokedReason: "你的开发者权限已收回：{reason}",
    unknown: "未知设备",
  },
  shell: {
    workspaceAdmin: "管理工作区",
    workspaceCurrent: "当前工作区",
    noTenant: "未选择租户",
    roleSuper: "平台超级管理员 · 登录于 {tenant}",
    roleAdmin: "租户管理员",
    roleMember: "身份成员",
    navLabel: "主导航",
    navPersonal: "日常",
    navInbox: "消息",
    navBuild: "开发",
    navPayout: "结算",
    navManage: "管理",
    closeNav: "关闭导航",
    openNav: "打开导航",
    scrollBack: "向左滚动",
    scrollForward: "向右滚动",
    commandPalette: "命令面板",
    commandHint: "命令面板 (Ctrl/⌘ K)",
    notifications: "通知",
    notificationsEmpty: "登录异常和管理员操作的通知在这里汇总。开关保存在你的偏好里。",
    manageNotifications: "管理通知",
    memberFallback: "身份成员",
    workspaceFallback: "工作区",
    skip: "跳到主要内容",
    profileMenu: "账户菜单",
    quickActions: "快捷操作",
  },
  users: {
    selfDisableHint: "不能停用或封禁自己的账号",
    roleGroups: "权限组",
    roleGroupsHint: "只调整直接授予的权限组。用户组继承的角色仍显示在成员列表里。",
    roleGroupsSelf: "不能调整自己的权限组。",
    roleGroupsSaved: "用户资料和权限组已保存",
    roleGroupsRemoveTitle: "收回这些权限组？",
    roleGroupsRemoveHint: "将移除直接授予的权限组：{roles}。对应权限会立即失效，并写入审计。",
    roleGroupsRemoveOk: "收回权限组",
    superAdmin: "超级管理员",
    protectedHint: "超级管理员的个人数据仅限超级管理员管理",
    protectedRelationsHint: "此角色或分组关联超级管理员，仅限超级管理员修改",
    eyebrow: "成员目录",
    title: "用户与邀请",
    description: "创建、邀请、停用或永久移除成员；批量操作会影响登录能力。",
    searchPlaceholder: "搜索姓名、邮箱、角色或用户组",
    statusPlaceholder: "账号状态",
    statusActive: "正常",
    statusInactive: "停用",
    statusBanned: "封禁",
    bulkDeactivate: "批量停用",
    bulkNeedSelection: "先勾选要停用的启用账号",
    bulkTitle: "批量停用 {count} 个已选账号？",
    bulkConsequence: "这 {count} 个账号将无法继续登录。受 last-admin 保护的账号会被跳过并记入失败列表。",
    bulkOk: "批量停用",
    bulkDone: "已批量停用 {succeeded} 人，失败 {failed}",
    invite: "邀请成员",
    create: "创建用户",
    loadFailed: "用户管理接口不可用",
    empty: "暂无用户",
    noMatch: "没有符合当前搜索或状态的用户",
    selectUser: "选择 {name}",
    colUser: "用户",
    colRoles: "角色",
    colGroups: "用户组",
    colStatus: "状态",
    colOnline: "在线状态",
    colLastLogin: "最近登录",
    colLastIP: "上次登录 IP",
    online: "在线",
    offline: "离线",
    moreRoles: "+{count} 个权限组",
    colActions: "操作",
    mfaOn: "已启用",
    mfaOff: "未启用",
    edit: "编辑",
    resetPassword: "重置密码",
    deactivate: "停用",
    deactivateTitle: "停用 {name}？",
    deactivateConsequence: "停用后该账号无法继续登录。",
    deleteForever: "永久删除",
    invitesTitle: "待处理邀请",
    invitesHint: "一次性链接，7 天有效；可绑定普通成员或租户管理员角色。",
    invitesLoadFailed: "无法读取邀请列表",
    invitesEmpty: "当前没有待接受的邀请。",
    roleAdmin: "租户管理员",
    roleSuper: "超级管理员",
    roleMember: "普通成员",
    noRole: "未分配",
    noGroup: "未加入",
    inviteExpires: "到期 {time}",
    invitePending: "待接受",
    revokeInvite: "撤销",
    revokeInviteTitle: "撤销邀请？",
    revokeInviteConsequence: "撤销后链接立即失效。",
    updated: "用户资料已更新",
    created: "用户已创建于 {tenant}",
    updateFailed: "更新失败",
    createFailed: "创建失败",
    inviteCreated: "邀请已创建",
    inviteLinkHint: "可复制链接发给受邀人（邮件发送取决于 SMTP 配置）",
    inviteLink: "邀请链接",
    inviteFailed: "邀请失败",
    inviteRevoked: "邀请已撤销",
    revokeFailed: "撤销失败",
    passwordReset: "密码已重置，原有会话已失效",
    passwordResetFailed: "密码重置失败",
    deactivated: "账号已停用",
    deactivateFailed: "停用失败",
    deleted: "用户数据已永久删除",
    deleteFailed: "永久删除失败",
    editTitle: "编辑 {name}",
    createTitle: "在 {tenant} 创建用户",
    username: "用户名",
    usernameRule: "请输入至少 3 个字符的用户名",
    email: "邮箱",
    emailRule: "请输入有效邮箱",
    fullName: "姓名",
    phone: "电话",
    avatar: "头像 URL",
    accountEnabled: "账号启用",
    accountBanned: "账号封禁",
    banReason: "封禁原因",
    initialPassword: "初始密码",
    passwordPolicyHint: "必须满足该租户当前的密码策略。",
    passwordRule: "密码至少 8 位",
    saveProfile: "保存用户资料",
    inviteTitle: "邀请成员加入 {tenant}",
    role: "角色",
    sendInvite: "发送邀请",
    resetTitle: "重置 {name} 的密码",
    resetWarning: "保存后，该用户的现有会话将立即失效",
    resetHint: "新密码必须满足当前租户的密码策略，请通过安全渠道交付。",
    newPassword: "新密码",
    confirmPassword: "确认新密码",
    confirmPasswordRule: "请再次输入新密码",
    passwordMismatch: "两次输入的密码不一致",
    deleteTitle: "永久删除用户",
    deleteWarning: "此操作无法撤销",
    deleteHint: "账号、会话、令牌、MFA 凭据、授权、关联身份及个人资料都会被物理删除。",
    deleteConfirm: "请输入用户名 {name} 以确认：",
  },
  protocol: {
    oidc: "OIDC Discovery",
    jwks: "JSON Web Key Set",
    saml: "SAML IdP Metadata",
    scim: "SCIM ServiceProviderConfig",
    refresh: "刷新",
    loadFailed: "无法读取 {name}",
    scimHint: "需要当前租户管理员会话。确认登录身份有权访问该工作区后重试。",
    genericHint: "身份服务没有返回可读内容。稍后重试，或检查该租户的协议是否已启用。",
  },
  platform: {
    domainsTitle: "可信域名",
    domainsHint: "管理平台门户 Host 与后端允许接收跨域请求的 Origin。",
    domainsLoadFailed: "平台域名配置接口不可用",
    adminHost: "平台管理域名",
    origins: "允许的 Origin（每行一个）",
    restartCors: "保存后需要重启身份服务，CORS 边界才会更新",
    saveDomains: "验证并保存",
    domainsSaved: "域名边界已保存",
    domainsRestart: "域名边界已保存，重启身份服务后生效",
    saveFailed: "保存失败",
    runtimeTitle: "运行配置",
    runtimeHint: "Secret 始终脱敏；留空表示保留当前值。数据库与 Redis 连接会在保存前测试。",
    runtimeLoadFailed: "运行配置接口不可用",
    externalUrl: "外部服务 URL",
    databaseDsn: "PostgreSQL DSN{configured}",
    configured: "（已配置）",
    keepBlank: "留空则不修改",
    redisAddr: "Redis 地址",
    redisDb: "Redis DB",
    redisPassword: "Redis 密码{configured}",
    smtpHost: "SMTP Host",
    smtpPort: "SMTP 端口",
    smtpUser: "SMTP 用户名",
    smtpPassword: "SMTP 密码{configured}",
    smtpFrom: "发件人",
    smtpTls: "启用 SMTP TLS",
    restartRuntime: "保存后需要重启身份服务",
    saveRuntime: "验证并保存",
    runtimeSaved: "运行配置已保存",
    runtimeRestart: "运行配置已保存，请重启身份服务",
    reauthTitle: "确认是你本人",
    reauthHint: "保存域名或运行配置前，输入当前账号的密码。密码只用于本次核对，不会写入配置。",
    currentPassword: "当前密码",
    reauthFailed: "密码不正确，配置未保存",
    reauthConfirm: "核对并继续",
    eyebrow: "平台控制台",
    title: "OwO! Identity 控制平面",
    description: "管理全部租户、运行配置与服务健康。关键修改会写入审计并明确重启要求。",
    tabTenants: "租户",
    tabDossier: "用户档案",
    tabAdmins: "系统管理",
    tabCompliance: "合规",
    tabHealth: "系统健康",
    tabDomains: "域名边界",
    tabRuntime: "运行配置",
    tabMail: "发信模板",
    tabNotices: "收件箱",
    noticePolicyEyebrow: "通知",
    noticePolicyTitle: "收件箱事件",
    noticePolicyHint: "这些开关对全平台生效。打开后，对应事件会写入收件箱；关闭后不再投递。新设备登录、密码变更、安全策略和开发者申请默认打开。个人仍可退订登录类和管理类通知。",
    noticePolicySearch: "搜索事件或动作",
    noticePolicySaved: "收件箱开关已保存",
    noticePolicyFailed: "无法保存收件箱开关",
    noticePolicyLoadFailed: "无法读取收件箱开关",
    noticePolicyEmpty: "没有匹配的事件",
    noticeAudienceSelf: "发给当事人",
    noticeAudienceTenant: "发给租户管理员",
    noticeAudiencePlatform: "发给超级管理员",
    tabOps: "队列与日志",
    tabLoad: "负载",
    tabAssets: "资产",
    smtpProbe: "测试 SMTP",
    smtpProbeTitle: "测试当前 SMTP",
    smtpProbeHint: "只测试正在运行的服务，不使用尚未保存的表单。留空收件人时只检查连接和登录，不发信。",
    smtpProbeTo: "测试收件人，可留空",
    smtpProbeOk: "SMTP 连接和登录成功",
    smtpProbeSent: "SMTP 测试邮件已发出",
    smtpProbeFailed: "SMTP 测试失败",
    opsEyebrow: "运维",
    opsTitle: "队列与审计",
    opsHint: "队列显示待投递任务。平台本身的运行日志和审计，与各租户审计分开列出。",
    opsRefresh: "刷新",
    queueDead: "死信",
    queuePending: "待处理",
    queueProcessing: "处理中",
    queueDone: "已完成",
    queueLoadFailed: "无法读取队列",
    queueEmpty: "这个状态下没有任务",
    opsWhen: "时间",
    opsEvent: "事件",
    opsReason: "原因",
    opsStatus: "状态",
    opsAttempts: "尝试次数",
    opsError: "错误",
    opsViewOps: "运维",
    opsViewAttention: "需要处理",
    opsViewPlatform: "平台",
    opsViewTenant: "租户",
    opsLogEyebrow: "租户",
    opsLogTitle: "租户审计",
    opsLogHint: "每条记录标明来源租户、OIDC 应用和用户。可按租户、事件、资源、IP 或追踪号筛选。",
    opsSearch: "搜索资源、IP 或追踪号",
    opsAction: "事件名，精确匹配",
    opsOutcome: "结果",
    opsAnyOutcome: "全部结果",
    opsFailures: "只看失败",
    opsSuccesses: "只看成功",
    opsResource: "资源",
    opsTrace: "追踪号",
    opsLogLoadFailed: "无法读取审计日志",
    opsLogEmpty: "没有匹配的日志",
    opsDetailTruncated: "详情过长，已省略。请到租户审计导出查看完整记录。",
    opsFailureEyebrow: "需要处理",
    opsFailureTitle: "失败与错误",
    opsFailureHint: "按失败、警告和错误分开查看。失败是没有成功的平台审计和租户审计；警告和错误是对应级别的运行日志。",
    opsSeverityFailure: "失败",
    opsSeverityWarning: "警告",
    opsSeverityError: "错误",
    opsFailureAll: "全部",
    opsFailureLogs: "运行日志",
    opsFailurePlatformAudit: "平台审计",
    opsFailureTenantAudit: "租户审计",
    opsFailureKind: "类型",
    opsFailureSearch: "搜索失败记录、追踪号或 IP",
    opsFailureEmpty: "没有需要处理的失败或错误",
    opsFailureLoadFailed: "无法读取失败记录",
    opsPlatformEyebrow: "平台",
    opsPlatformTitle: "平台本身",
    opsPlatformHint: "只看身份服务自己产生的记录，不把它们混进某一个租户。",
    opsPlatformLogTitle: "运行日志",
    opsPlatformLogHint: "控制台请求、启动、发信探针，以及域名和运行配置变更。健康探针和指标抓取不记入。",
    opsPlatformAuditTitle: "平台审计",
    opsPlatformAuditHint: "签名密钥、超级管理员、发信模板和平台配置。展开一行可看详情。",
    opsTenantFilter: "租户",
    opsAllTenants: "全部租户",
    opsOrigin: "来源",
    opsApp: "OIDC 应用",
    opsUser: "用户",
    opsLevel: "级别",
    opsSource: "记录源",
    opsMessage: "记录",
    opsAnyLevel: "全部级别",
    opsAnySource: "全部记录源",
    opsPlatformScope: "平台",
    opsTenantMissing: "租户未找到",
    opsClientUnnamed: "名称未登记",
    opsNoApp: "没有关联应用",
    opsNoUser: "没有关联用户",
    opsUserMissing: "用户未找到",
    opsUserCard: "查看 {name} 的资料",
    opsEmail: "邮箱",
    opsGroups: "分组",
    opsPermissions: "权限",
    opsLastLogin: "上次登录",
    opsRegistered: "注册日期",
    opsNever: "尚未登录",
    opsNoGroups: "没有分组",
    opsNoPermissions: "没有权限",
    opsActor: "操作者",
    opsPlatformLogEmpty: "还没有平台运行日志",
    opsPlatformAuditEmpty: "还没有平台审计",
    opsPlatformLogLoadFailed: "无法读取平台运行日志",
    opsPlatformAuditLoadFailed: "无法读取平台审计",
    opsLogSearch: "搜索记录、追踪号或 IP",
    mailEyebrow: "SMTP",
    mailTitle: "发信模板",
    mailHint: "默认使用系统内置模板。打开自定义后，发信改用你保存的正文。占位符在发送时替换，脚本和未知字段会被拒绝。公告邮件可按等级独立启用，并发送到对应受众中邮箱已验证的活跃用户。",
    mailSearch: "搜索事件或模板",
    mailSystem: "系统发信",
    mailEvents: "事件触发",
    mailUseCustom: "使用自定义模板",
    mailUseCustomHint: "关闭时发送系统内置模板。",
    mailEnable: "此事件发生时发信",
    mailEnableHint: "默认不发。打开后，事件中的用户会收到这封邮件。",
    mailSubject: "主题",
    mailBody: "正文",
    mailFields: "保留字段",
    mailFieldsHint: "在正文中写入 {username} 这类字段，发送时替换为对应内容。",
    mailPreview: "预览当前正文",
    mailPreviewSystem: "预览系统模板",
    mailSave: "保存模板",
    mailSaved: "模板已保存",
    mailSaveFailed: "模板保存失败",
    mailReset: "恢复系统模板",
    mailResetTitle: "恢复系统模板？",
    mailResetHint: "已保存的自定义正文会被删除。之后发送重新使用系统模板。",
    mailResetOk: "恢复系统模板",
    mailResetDone: "已恢复系统模板",
    mailLoadFailed: "无法读取发信模板",
    mailEmpty: "没有匹配的事件",
    mailInlineHint: "账号流程会发送这封邮件。关闭自定义时使用系统模板。",
    mailBusHint: "这条来自事件管理器。只有打开「此事件发生时发信」才会发送。",
    mailSubjectRequired: "填写主题",
    mailBodyRequired: "填写正文",
    mailEventVerification: "邮箱验证",
    mailEventReset: "重置密码",
    mailEventInvitation: "邀请加入",
    mailEventSecurity: "安全提醒",
    mailEventTemplate: "模板已更新",
    mailEventBillCreated: "账单已创建",
    mailEventBillPaid: "账单已支付",
    mailEventWithdrawalSubmitted: "提现申请已提交",
    mailEventWithdrawalApproved: "提现申请已批准",
    mailEventWithdrawalRejected: "提现申请已拒绝",
    mailEventWithdrawalProcessed: "提现已打款",
    mailEventAnnouncementInfo: "信息级公告",
    mailEventAnnouncementWarning: "警告级公告",
    mailEventAnnouncementCritical: "严重级公告",
    mailCustomMark: "自定义",
    mailEnabledMark: "已启用",
    adminsEyebrow: "平台权限组",
    adminsTitle: "系统管理",
    adminsHint: "Super Administrator 是平台级权限组。只能在这里授予或收回。租户不能创建或分配它。",
    groupScope: "平台",
    groupStamp: "系统",
    groupReadonly: "这组权限由平台目录维护，租户角色不能勾选。",
    groupPerms: "系统管理包含的权限",
    groupEmpty: "权限目录还没有平台项。完成数据库迁移后会显示。",
    groupLoadFailed: "无法读取平台权限组",
    membersEyebrow: "成员",
    membersTitle: "组成员",
    membersHint: "授予后，该用户立即拥有平台控制台。系统至少保留一名可用超级管理员。",
    userUuid: "用户 UUID",
    pickUser: "用户名或邮箱",
    pickEmpty: "没有匹配的用户",
    alreadyAdmin: "已是平台管理员",
    selectUser: "选择 {name}",
    revokeLast: "至少保留一名平台管理员",
    revokeFailed: "撤销失败",
    grant: "授予",
    grantTitle: "授予超级管理员",
    grantHint: "向 {name} 授予平台控制台前，请输入二级密码。",
    granted: "已授予超级管理员",
    grantFailed: "授权失败",
    revokeTitle: "撤销超级管理员？",
    revokeHint: "该用户将立即失去平台级权限。若这是最后一名可用超级管理员，操作会被拒绝。",
    revokeOk: "撤销授权",
    revoked: "已撤销授权",
    adminsLoadFailed: "无法读取超级管理员列表",
    adminsEmpty: "尚未授予超级管理员",
    user: "用户",
    status: "状态",
    actions: "操作",
    inactive: "停用",
    available: "可用",
    revoke: "撤销",
    tenantsEyebrow: "租户编目",
    tenantsTitle: "平台租户",
    tenantsHint: "进入管理可配置该工作区的成员、协议与访问边界，无需切换登录身份。",
    createTenant: "创建租户",
    tenantsLoadFailed: "无法读取租户",
    tenantsEmpty: "暂无租户",
    tenant: "租户",
    running: "运行中",
    stopped: "已停用",
    createdAt: "创建时间",
    manage: "进入管理",
    editProfile: "编辑资料",
    disableTitle: "停用 {name}？",
    disableHint: "该租户的用户和应用将立即无法访问服务，直至重新启用。",
    disableOk: "停用租户",
    disable: "停用",
    purge: "永久移除",
    editTenant: "管理租户",
    slug: "租户 Slug",
    internalName: "内部名称",
    displayName: "显示名称",
    enableTenant: "启用租户",
    registration: "允许用户自行注册",
    registrationExtra: "关闭后公开注册接口与登录页注册入口不可用。邀请入驻仍可用。",
    registrationColumn: "自行注册",
    registrationOpen: "开放",
    registrationClosed: "关闭",
    registrationToggle: "切换 {name} 的自行注册",
    registrationOn: "已开放自行注册",
    registrationOff: "已关闭自行注册",
    registrationOffTitle: "关闭 {name} 的自行注册？",
    registrationOffHint: "公开注册入口和注册接口会立即停止接受新账号。已有用户登录和邀请入驻不受影响。",
    registrationOffOk: "关闭注册",
    registrationFailed: "无法更新注册权限",
    forcePar: "租户强制推送授权",
    forceParExtra: "打开后该租户所有授权请求都必须先推送参数。",
    risk: "启用登录风控 step-up",
    riskExtra: "关闭后不再因异地/新设备等信号强制 MFA。",
    newIp: "新 IP 强制 MFA",
    newDevice: "新设备强制 MFA",
    stepScore: "Step-up 最低分",
    stepScoreExtra: "默认 50；达到该分且已登记 MFA 时强制 step-up。",
    archiveNote: "冷归档由服务器 retention.archive_* 控制",
    archiveHint: "开启后到期审计/会话/邀请会先写入 JSONL（fs 或 S3）再 purge。详见后端 runbook audit-cold-archive。",
    auditDays: "审计留存（天）",
    auditDaysExtra: "0 表示永久保留；上限 3650。",
    sessionDays: "会话留存（天）",
    inviteDays: "邀请留存（天）",
    deletedDays: "已删用户留存（天）",
    saveTenant: "保存租户",
    tenantUpdated: "租户已更新",
    tenantCreated: "租户已创建",
    tenantDisabled: "租户已停用",
    disableFailed: "停用失败",
    purgeTitle: "永久移除租户",
    purgeOk: "永久删除",
    irreversible: "此操作无法撤销",
    purgeHint: "该租户的用户、凭据、会话、应用、授权、SAML 配置及审计数据都会被物理删除。",
    purgeLead: "请输入租户 Slug ",
    purgeTail: " 以确认：",
    tenantPurged: "租户及其全部数据已永久删除",
    purgeFailed: "永久删除失败",
    complianceEyebrow: "合规态势",
    complianceTitle: "留存与会话健康",
    complianceHint: "查看各租户热库规模与冷归档批次。可按发行区域筛会话；强制重登会立即踢下线。",
    refreshPosture: "刷新态势",
    regionRequired: "请先填写发行区域",
    forceTitle: "强制区域「{region}」重新登录？",
    forceHint: "该区域下所有匹配的活跃会话会立即失效：刷新令牌被撤销，访问令牌被拉黑。用户需要重新登录。",
    forceOk: "强制重登",
    forced: "已强制重登 {count} 个会话",
    forceFailed: "强制重登失败",
    postureWatch: "需关注",
    postureCalm: "平稳",
    postureNow: "当前态势：{tone}",
    archiveFailedLine: "有 {count} 个归档失败批次，热库行可能未按期清理。",
    archiveClear: "归档批次无失败。",
    outboxDead: "Outbox 死信 {count} 条，请检查投递。",
    outboxClear: "Outbox 无死信。",
    noBatches: "冷归档尚未产生批次",
    noBatchesHint: "热库数据仍按租户留存天数保留。若要先归档再清理，请在服务器启用 retention.archive_enabled（fs 或 s3），说明见运行配置页。",
    openRuntime: "打开运行配置",
    archiveFailed: "归档失败批次",
    outboxDeadTitle: "Outbox 死信",
    generatedAt: "生成时间",
    complianceLoadFailed: "无法读取合规概览",
    complianceEmpty: "还没有可展示的租户态势。先创建或启用一个工作区。",
    openTenants: "打开租户编目",
    auditRows: "审计行",
    sessions: "会话",
    invitations: "邀请",
    archiveDone: "归档成功",
    archiveFailCol: "归档失败",
    latestArchive: "最近归档",
    regionEyebrow: "会话区域",
    regionTitle: "按发行区域排查",
    regionHint: "发行区域是会话创建时写入的区域标签。强制重登会撤销刷新令牌并拉黑访问令牌。",
    regionPlaceholder: "发行区域，例如 ap-east-1",
    regionLabel: "发行区域",
    forceRegion: "强制该区域重登",
    sessionsLoadFailed: "无法读取会话",
    sessionsEmpty: "没有匹配的活跃会话。可换一个发行区域，或确认冷归档/留存策略是否已在运行配置中说明。",
    viewRuntime: "查看运行配置说明",
    unmarked: "未标记",
    client: "客户端",
    created: "创建",
    http: "HTTP 服务",
    healthy: "正常",
    down: "异常",
    stores: "PostgreSQL / Redis",
    ready: "就绪",
    notReady: "不可用",
    startup: "启动检查",
    checking: "检查中",
    metrics: "指标采集",
    metricsOk: "可用",
    refresh: "刷新",
    metricsLoading: "正在读取指标...",
  },
  login: {
    thesis: "一把钥匙，打开该开的门。",
    thesisBody: "OwO! Identity 把登录、授权与安全状态收进同一控制面——先确认是你，再决定能去哪里。",
    isolation: "租户隔离",
    isolationHint: "每次访问都绑定明确工作区",
    mfa: "多因素认证",
    mfaHint: "动态码、备用码与安全密钥",
    eyebrow: "安全登录",
    title: "进入 OwO! Identity",
    intro: "使用你的工作区和账号继续。",
    signedOut: "这个设备的登录已被其他设备退出，请重新登录。",
    workspace: "工作区",
    workspaceRequired: "请输入工作区",
    workspacePlaceholder: "例如 master 或 acme",
    workspaceFixedLead: "此应用已指定工作区",
    workspaceFixedTail: "。登录、注册和找回密码都留在这个工作区。",
    login: "用户名或邮箱",
    loginRequired: "请输入用户名或邮箱",
    password: "密码",
    passwordRequired: "请输入密码",
    submit: "登录",
    forgot: "忘记密码",
    registerLink: "注册账号",
    registerTitle: "创建账号",
    registerIntro: "在此工作区自行注册。",
    registerSubmit: "注册",
    registerSuccess: "账号已创建。请先验证邮箱，再登录。",
    registerFailed: "注册失败",
    registerMailFailed: "验证邮件没有发出，账号尚未创建。请稍后再提交。",
    registerExists: "这个用户名或邮箱已经有账号。请直接登录，或换一个再注册。",
    verifyEmailEyebrow: "邮箱验证",
    verifyEmailTitle: "验证邮箱",
    verifyEmailIntro: "验证码已发送到 {email}。验证通过后才能登录。",
    verifyEmailIntroOidc: "验证码已发送到 {email}。验证通过并登录后，才会继续进入应用。",
    verifyEmailCode: "验证码",
    verifyEmailCodeRequired: "请输入验证码",
    verifyEmailSubmit: "验证邮箱",
    verifyEmailResend: "重新发送验证码",
    verifyEmailResendWait: "{seconds} 秒后可重新发送",
    verifyEmailResent: "验证码已重新发送到 {email}。",
    verifyEmailResendFailed: "暂时无法重新发送验证码。",
    verifyEmailInvalid: "验证码无效或已过期。请重新输入，或重新发送。",
    verifyEmailDeliveryFailed: "验证码没有发出。请重新发送后再输入。",
    verifyEmailDoneTitle: "邮箱已验证",
    verifyEmailDone: "现在可以登录。",
    verifyEmailDoneOidc: "现在可以登录，然后继续进入应用。",
    verifyEmailSignIn: "去登录",
    registerDisabled: "此工作区已关闭自行注册。",
    registerUsername: "用户名",
    registerUsernameRequired: "请输入用户名",
    registerEmail: "邮箱",
    registerEmailRequired: "请输入邮箱",
    registerFullName: "显示名称",
    registerPassword: "密码",
    registerPasswordRequired: "请输入密码",
    backToSignIn: "返回登录",
    protected: "受保护的身份服务",
    back: "返回密码登录",
    stepEyebrow: "第二步验证",
    confirmTitle: "确认是你本人",
    confirmLead: "密码已通过。请完成 ",
    confirmTail: " 工作区要求的安全验证。",
    verify: "验证并登录",
    expires: "验证请求将在短时间后失效",
    totp: "身份验证器",
    totpShort: "动态码",
    totpHint: "输入身份验证器中显示的 6 位动态验证码。",
    backup: "备用码",
    backupShort: "备用码",
    backupHint: "输入一个尚未使用的备用码。验证后该代码将失效。",
    webauthn: "安全密钥",
    webauthnShort: "安全密钥",
    webauthnHint: "使用当前设备的 Passkey 或已注册的硬件安全密钥。",
    useKey: "使用安全密钥验证",
    backupPlaceholder: "输入备用码",
    noMethod: "此账号需要二次验证，但没有可用的验证方式",
    signInFailed: "无法登录，请检查服务连接",
    invalidCredentials: "用户名或密码不正确。请再试一次，或重置密码。",
    accountLocked: "账号已暂时锁定。请稍后再试，或重置密码。",
    accountBanned: "账号已停用。请联系管理员。",
    accountUnverified: "邮箱尚未验证。请先完成验证邮件后再登录。",
    loginDisabled: "此工作区已关闭密码登录。",
    enterCode: "请输入{method}",
    verifyFailed: "验证失败，请重新输入",
    keyUnsupported: "当前浏览器不支持安全密钥",
    keyCancelled: "安全密钥验证已取消",
    keyFailed: "安全密钥验证失败",
    forgotTitle: "找回密码",
    forgotOk: "发送重置邮件",
    forgotBody: "输入工作区和账号邮箱。如果账号存在，我们会发送一次性重置链接。",
    forgotBodyFixed: "重置邮件只会发往工作区 {workspace}。如果账号存在，链接会很快送达。",
    forgotWorkspace: "工作区，例如 master",
    forgotEmailMissing: "请输入邮箱地址",
    forgotEmail: "账号邮箱",
    requirementsTitle: "本工作区要求",
    lockoutHint: "连续失败 {attempts} 次后，账号锁定 {minutes} 分钟。",
    mfaRequired: "登录时必须完成第二步验证。",
    mfaOptional: "第二步验证由账号自己的安全设置决定。",
    passwordDisabled: "此工作区已关闭密码登录。",
    federationHint: "已启用的联邦身份源：{names}。密码登录后可在安全中心关联。",
    continueWith: "使用 {name} 继续",
    realmMatch: "{domain} 将使用 {name} 登录。",
    realmAmbiguous: "{domain} 对应多个身份源。请选择其中一个。",
    usePasswordInstead: "改用密码登录",
    passkey: "使用 Passkey 登录",
    passkeyMissing: "这个账号没有可用的 Passkey。请改用密码，或先在安全中心注册。",
    passkeyInvalid: "Passkey 验证失败。请再试一次，或改用密码。",
    passkeyFailed: "无法使用 Passkey 登录。",
    passkeyRecovery: "Passkey 丢失时，重置密码后仍可进入账号，再到安全中心注册一把新钥匙。",
    federationFailed: "无法使用该身份源登录。请改用密码，或联系管理员。",
    federationNotLinked: "这个外部账号还没有关联到工作区账号。请先用密码登录，再到安全中心关联。",
    federationDisabled: "此工作区尚未开放该身份源登录。",
    providerGoogle: "Google",
    providerGitHub: "GitHub",
    providerMicrosoft: "Microsoft",
    providerApple: "Apple",
    providerOkta: "Okta",
    providerOidc: "企业 OIDC",
    providerLdap: "企业目录",
    forgotMissing: "请输入工作区和邮箱地址",
    forgotSent: "如果账号存在，重置邮件将很快送达",
    forgotFailed: "暂时无法提交重置请求",
  },
  security: {
    eyebrow: "登录保护",
    title: "安全中心",
    description: "管理密码、多因素认证、登录设备和外部身份绑定。",
    sessionsTab: "登录活动",
    logsTab: "登录日志",
    mfaTab: "多因素认证",
    linksTab: "关联账号",
    passwordTab: "修改密码",
    devicesTitle: "登录设备与记录",
    devicesHint: "名称来自浏览器、系统和设备型号。活动会话可单独退出；已退出记录可以删除。",
    signOutOthers: "退出其他设备",
    sessionsLoadFailed: "登录记录接口不可用",
    sessionsEmpty: "暂无登录活动。",
    selectHistory: "选择本页已退出记录",
    deleteHistory: "删除历史",
    selectDevice: "选择 {name}",
    unknownDevice: "未知设备",
    unknownIp: "未知 IP",
    lastActive: "最近活动 {time}",
    scope: "权限 {scope}",
    currentDevice: "当前设备",
    active: "活动",
    signedOut: "已退出",
    displaced: "被挤下线",
    signOutDevice: "退出设备",
    deleteOne: "删除这条登录活动",
    signOutOthersTitle: "退出其他已登录设备？",
    signOutConfirm: "确认退出",
    signOutOthersAlert: "将退出除当前设备外的所有已登录设备",
    signOutOthersHint: "当前浏览器会保持登录，其他设备的会话会立即失效。",
    signOutOneTitle: "退出此设备？",
    signOutOneAlert: "该设备的刷新会话将立即失效",
    signOutOneHint: "当前浏览器不会受到影响。",
    deleteManyTitle: "删除 {count} 条历史记录？",
    deleteOneTitle: "删除这条登录活动？",
    deleteAlert: "历史记录将被永久删除",
    deleteHint: "只有已退出的会话记录可删除，此操作无法撤销。",
    deleted: "已删除 {count} 条登录活动",
    deleteFailed: "删除登录活动失败",
    deviceSignedOut: "该设备已退出登录",
    revokeFailed: "撤销会话失败",
    othersSignedOut: "已退出 {count} 个其他设备",
    noOtherDevices: "没有其他已登录设备",
    othersFailed: "退出其他设备失败",
    logsTitle: "最近登录日志",
    logsHint: "最近 100 次本地与联邦登录。失败事件用红色信号条标出，结果列与动作名保持一致。",
    logsLoadFailed: "登录日志接口不可用",
    logsEmpty: "暂无登录日志",
    logScope: "权限 {scope}",
    methodsTitle: "验证方式",
    methodsHint: "配置认证凭据，并决定登录时要求使用哪些验证方式。",
    methodsLoadFailed: "无法读取登录验证设置",
    authenticator: "身份验证器",
    totpOn: "已配置，登录时要求动态验证码",
    totpOff: "已配置，登录验证暂时关闭",
    totpNone: "使用兼容 TOTP 的动态验证码应用",
    loginToggle: "登录时验证",
    totpSwitch: "登录时使用身份验证器",
    passkeySwitch: "登录时使用 Passkey",
    disable: "停用",
    setup: "设置",
    passkeyTitle: "安全密钥 / Passkey",
    passkeyOn: "已配置，登录时可使用 Passkey 验证",
    passkeyOff: "已配置，登录验证暂时关闭",
    passkeyNone: "通过 WebAuthn 注册当前设备或硬件密钥",
    registerKey: "注册新密钥",
    backupTitle: "备用码",
    backupRemaining: "剩余 {count} 个，每个代码只能使用一次。",
    regenerate: "重新生成",
    disableTitle: "停用身份验证器？",
    disableOk: "停用并删除配置",
    disableAlert: "动态验证码将无法继续用于登录",
    disableHint: "此操作会删除当前 TOTP 密钥。如只需暂停登录验证，请关闭“登录时验证”开关。",
    setupTitle: "设置身份验证器",
    setupOk: "验证并启用",
    setupScan: "使用身份验证器扫描二维码，或手动输入密钥：",
    codeLabel: "6 位验证码",
    codePlaceholder: "输入 6 位验证码",
    replaceTitle: "覆盖现有备用码？",
    replaceOk: "覆盖并生成",
    replaceAlert: "生成后，所有旧备用码将立即失效",
    replaceHint: "请确认你已准备好保存新代码。此操作不会显示或恢复旧代码。",
    newCodes: "新的备用码",
    codesSaved: "我已安全保存",
    codesOnce: "这些代码只显示一次",
    codesHint: "每个代码只能使用一次。关闭此窗口前，请将它们保存在安全的位置。",
    copyCodes: "复制全部代码",
    setupIncomplete: "身份验证器设置响应不完整",
    setupFailed: "无法开始 TOTP 设置",
    codeRequired: "请输入身份验证器显示的 6 位验证码",
    totpEnabled: "身份验证器已启用",
    codeInvalid: "验证码无效，身份验证器尚未启用",
    totpDisabled: "身份验证器已停用",
    disableFailed: "停用失败",
    loginOn: "登录验证已开启",
    loginOff: "登录验证已关闭，已注册凭据仍会保留",
    loginUpdateFailed: "登录验证设置更新失败",
    passkeyUnsupported: "当前浏览器不支持 Passkey",
    passkeyCancelled: "Passkey 注册已取消",
    passkeyRegistered: "Passkey 已注册",
    passkeyFailed: "Passkey 注册失败",
    codesIncomplete: "备用码生成响应不完整",
    codesFailed: "生成失败",
    codesCopied: "备用码已复制",
    clipboardFailed: "无法访问剪贴板，请手动保存备用码",
    linksTitle: "外部身份",
    linksHint: "关联企业目录或常用开发者账号。",
    ldap: "企业 LDAP",
    popupBlocked: "浏览器阻止了授权窗口，请允许此站点打开弹窗",
    linked: "{name} 已关联",
    linkTitle: "关联 {name}",
    ldapUser: "LDAP 用户名",
    ldapPassword: "LDAP 密码",
    linkOk: "关联账号",
    unlinked: "关联已解除",
    unlinkFailed: "解除关联失败",
    linkedAs: "已关联",
    providerOff: "当前租户未启用此提供方",
    notLinked: "尚未关联",
    unlinkTitle: "解除 {name} 关联？",
    unlink: "解除",
    link: "关联",
    passwordTitle: "修改密码",
    passwordHint: "新密码必须满足当前租户的密码策略。",
    reviewActivity: "我已查看这些登录活动",
    reviewActivitySaved: "已记录查看时间",
    reviewActivityHint: "确认后，总览里的这项会在 30 天内显示为已完成。",
    reviewActivityFailed: "无法记录查看时间",
    currentPassword: "当前密码",
    newPassword: "新密码",
    savePassword: "保存新密码",
    passwordSaved: "密码已修改，其他会话已撤销",
    passwordFailed: "修改失败",
  },
  adminNav: {
    eyebrow: "租户控制台",
    title: "{tenant} 管理",
    acting: "正在以平台管理员身份管理 {tenant}，登录身份仍属于 {home}。",
    description: "管理成员、协议接入、安全边界和审计记录。",
    overview: "管理总览",
    users: "用户",
    roles: "角色",
    groups: "用户组",
    reviews: "访问评审",
    federation: "联邦登录",
    audit: "审计日志",
    ip: "IP 规则",
    oidc: "OIDC 应用",
    saml: "SAML 服务",
    protocol: "协议诊断",
    policy: "安全策略",
    developers: "开发者申请",
    activeToday: "今日活跃用户",
    newWeek: "7 日新增",
    failedHour: "1 小时失败登录",
    sessions: "活跃会话",
    mfaRate: "MFA 采用率",
  },
  passwordRules: {
    title: "密码必须满足",
    minLength: "至少 {count} 个字符",
    upper: "包含大写字母",
    lower: "包含小写字母",
    digit: "包含数字",
    special: "包含符号",
    history: "不能与最近 {count} 次密码相同。这一条由服务器在保存时核对。",
  },
  adminPolicy: {
    title: "安全策略",
    hint: "这些规则会立即出现在登录、注册和改密页面。自行注册开关仍在平台控制台。",
    save: "保存安全策略",
    saved: "安全策略已保存",
    unchanged: "安全策略没有变化",
    failed: "无法保存安全策略",
    loadFailed: "无法读取安全策略",
    passwordSection: "密码",
    lockoutSection: "锁定",
    mfaSection: "第二步验证",
    sessionSection: "会话",
    riskSection: "风险升级",
    minLength: "最短长度",
    requireUpper: "需要大写字母",
    requireLower: "需要小写字母",
    requireDigit: "需要数字",
    requireSpecial: "需要符号",
    historyCount: "禁止重复的最近次数",
    maxFailed: "失败次数上限",
    lockoutMinutes: "锁定分钟",
    mfaPolicy: "登录时的第二步验证",
    mfaOptional: "按账号设置",
    mfaRequired: "每次登录都要求",
    accessTtl: "访问令牌秒数",
    refreshTtl: "刷新令牌秒数",
    maxDevices: "每应用设备上限",
    riskEnabled: "启用风险升级",
    riskNewIp: "新 IP 要求第二步验证",
    riskNewDevice: "新设备要求第二步验证",
    riskScore: "升级分数阈值",
    federationSection: "联邦登录",
    federationLogin: "允许使用已配置的联邦身份源登录",
    federationLoginHint: "打开后，登录页显示这些身份源。密码登录保持可用。",
    methodsHint: "允许的登录方式由身份源配置决定，这里只展示：{methods}。",
  },
  palette: {
    home: "工作台总览",
    account: "账号资料",
    apps: "应用与授权",
    security: "安全中心",
    settings: "系统设置",
    docs: "对接文档",
    admin: "租户管理",
    users: "成员目录",
    usersHint: "用户面板",
    oidc: "OIDC 应用",
    audit: "审计信号带",
    platform: "平台控制台",
    systemGroup: "系统管理",
    systemGroupHint: "平台权限组",
    compliance: "合规态势",
    complianceHint: "合规页",
    runtime: "运行配置",
    runtimeHint: "冷归档相关说明",
    mail: "发信模板",
    mailHint: "SMTP 模板",
    ops: "队列与日志",
    opsHint: "平台日志与租户审计",
    workspace: "工作区 {slug}",
    nav: "导航",
    manage: "管理",
    platformGroup: "平台",
    tenants: "租户",
    placeholder: "搜索页面、租户或能力…",
    search: "命令面板搜索",
    empty: "没有匹配项。试试页面名、租户或工作区 slug。",
    hint: "Enter 打开首条 · Esc 关闭 · Ctrl/⌘ K 再次打开",
  },
  boot: {
    title: "暂时无法连接身份服务",
    hint: "初始化状态未能读取。请检查后端、数据库和网络连接后重试。",
    retry: "重新检查",
    loading: "正在进入工作区",
  },
  notFound: {
    title: "找不到这个页面",
    hint: "地址可能不正确，或者你没有访问此工作区的权限。",
    back: "返回总览",
  },
  roles: {
    eyebrow: "成员目录",
    title: "角色与权限",
    description: "系统角色「租户管理员」会写进本租户 OIDC 令牌的 roles。应用看到 tenant_admin 就是租户管理员，没有这个角色就是普通用户。自定义角色只能分配租户范围内的权限。",
    create: "创建自定义角色",
    created: "自定义角色已创建",
    createFailed: "创建失败",
    deleteTitle: "删除角色 {name}？",
    deleteHint: "将移除所有用户与用户组上的该角色绑定。",
    deleted: "角色已删除",
    deleteFailed: "删除角色失败",
    assigned: "已为用户分配角色",
    assignFailed: "分配失败",
    permsSaved: "角色权限已更新（用户需重新登录后 JWT 生效）",
    saveFailed: "保存失败",
    catalogCount: "权限目录 {count} 项",
    catalogHint: "这里只列出租户范围内的权限。平台权限组在平台控制台，不能分配给自定义角色。",
    reserved: "OIDC 可识别",
    reservedHint: "租户应用用角色名 tenant_admin 区分租户管理员和普通用户。这个角色不能删除，权限由平台目录维护。",
    alreadyAssigned: "已分配",
    selfAssign: "不能调整自己",
    lastAdmin: "不能移除最后一名租户管理员",
    assignedEyebrow: "已分配",
    assignedTitle: "权限组中的用户",
    assignedHint: "从这里收回直接授予。已经分配的账号不能在分配框里再次选中。移除会写入审计，并按事件模板发信。",
    assignedEmpty: "还没有用户被直接授予这些权限组。",
    assignedLoadFailed: "无法读取已分配用户",
    assignedRemove: "移除",
    assignedRemoveTitle: "从 {role} 移除 {name}？",
    assignedRemoveHint: "该用户会立即失去这个权限组。操作写入审计；若已启用发信，对方会收到通知。",
    assignedRemoved: "已从 {role} 移除 {name}",
    loadFailed: "无法读取角色",
    empty: "暂无角色",
    name: "名称",
    type: "类型",
    system: "系统",
    custom: "自定义",
    note: "说明",
    actions: "操作",
    assignUser: "分配用户",
    permissions: "权限",
    delete: "删除",
    slug: "标识（小写 slug）",
    slugHint: "如 finance_reader",
    displayName: "显示名称",
    createOk: "创建",
    assignTitle: "分配角色 {name}",
    user: "用户",
    assignOk: "分配",
    permsTitle: "权限 · {name}",
    close: "关闭",
    savePerms: "保存权限",
    systemReadonly: "系统角色权限由平台目录维护，只读。",
    pickPerms: "选择权限",
  },
  groups: {
    eyebrow: "成员目录",
    title: "用户组",
    description: "组内成员自动继承组上绑定的角色；登录后 JWT roles 会合并直接角色与组继承角色。",
    create: "创建用户组",
    created: "用户组已创建",
    createFailed: "创建失败",
    deleteTitle: "删除用户组 {name}？",
    deleted: "用户组已删除",
    memberAdded: "成员已加入",
    addFailed: "添加失败",
    memberRemoved: "成员已移除",
    roleBound: "角色已绑定到组",
    bindFailed: "绑定失败",
    roleRemoved: "组角色已移除",
    loadFailed: "无法读取用户组",
    empty: "暂无用户组",
    name: "名称",
    members: "成员",
    roles: "角色",
    actions: "操作",
    manage: "管理",
    delete: "删除",
    slug: "标识（小写 slug）",
    slugHint: "如 ops-team",
    displayName: "显示名称",
    note: "说明",
    createOk: "创建",
    manageTitle: "管理用户组 {name}",
    pickUser: "选择用户",
    addMember: "添加成员",
    remove: "移除",
    groupRoles: "组角色",
    pickRole: "选择角色",
    bindRole: "绑定角色",
    unbind: "解除",
  },
  reviews: {
    eyebrow: "治理",
    title: "访问评审",
    description: "创建评审后对成员执行保留（attest）或撤销（revoke=停用）。受 last-admin 保护的账号无法被撤销。",
    placeholder: "评审名称，如 2026-Q3 权限复核",
    create: "创建评审",
    created: "访问评审已创建",
    createFailed: "创建失败",
    attested: "已确认保留",
    revoked: "已撤销并停用账号",
    completed: "评审已完成",
    loadFailed: "无法读取访问评审",
    empty: "还没有访问评审。输入名称后创建第一轮复核。",
    name: "名称",
    status: "状态",
    createdAt: "创建时间",
    actions: "操作",
    open: "打开",
    titleWith: "评审 {name}",
    close: "关闭",
    complete: "标记完成",
    user: "用户",
    decision: "结论",
    attest: "保留",
    revoke: "撤销",
  },
  ip: {
    eyebrow: "访问边界",
    title: "IP 规则",
    description: "deny 规则作用于租户 API；存在 allow 规则时，管理接口只允许匹配地址。",
    created: "IP 规则已创建",
    createFailed: "创建失败",
    cidrRequired: "请填写 CIDR",
    allow: "允许",
    deny: "拒绝",
    reason: "用途说明",
    add: "添加",
    loadFailed: "无法读取 IP 规则",
    empty: "尚未配置 IP 规则。添加第一条允许或拒绝网段。",
    addRule: "添加规则",
    noReason: "未填写说明",
  },
  pager: {
    label: "分页",
    range: "{start}–{end}，共 {total} 条",
    perPage: "每页条数",
    custom: "自定义",
    prev: "上一页",
    next: "下一页",
    page: "第 {page} / {pages} 页",
  },
  audit: {
    eyebrow: "审计",
    title: "审计信号带",
    description: "每条记录左侧色条表示执行等级；失败类动作不会再被标成成功。",
    filter: "按动作、标签、用户或 IP 筛选",
    csv: "CSV（表格）",
    ndjson: "NDJSON（SIEM 流）",
    cef: "CEF（安全设备）",
    export: "导出",
    loadFailed: "无法读取审计日志",
    noMatch: "没有匹配的审计记录",
    empty: "暂无审计记录",
    time: "时间",
    level: "等级",
    action: "动作",
    eventName: "元名称",
    resource: "资源",
    user: "用户",
    actor: "操作者",
    result: "结果",
    purgeTenant: "清理审计日志",
    purgePlatform: "清理平台审计",
    purgeTitle: "确认清理审计日志",
    purgeAlert: "删除后不能从热存储恢复。若已开启冷归档，会先写入归档。",
    purgeRange: "按时间范围",
    purgeAll: "全部",
    purgeMode: "清理方式",
    subject: "对象",
    subjectPlatform: "平台审计",
    subjectTenant: "租户",
    subjectUser: "用户",
    subjectClient: "OIDC 应用",
    subjectId: "对象标识",
    from: "开始时间",
    to: "结束时间",
    reason: "原因",
    purgeConfirm: "清理",
    purgeFailed: "清理失败",
  },
  saml: {
    eyebrow: "协议接入",
    title: "SAML Service Provider",
    description: "注册 ACS、SLO、证书与 Metadata；支持签名证书重叠轮换。",
    register: "注册 SP",
    updated: "SAML Service Provider 已更新",
    registered: "SAML Service Provider 已注册",
    updateFailed: "更新失败",
    registerFailed: "注册失败",
    disabled: "SAML SP 已停用",
    disableFailed: "停用失败",
    purged: "SAML Service Provider 已永久删除",
    purgeFailed: "永久删除失败",
    rotateTitle: "轮换 {name} 的签名证书？",
    rotateBody: "当前证书将进入重叠窗口（默认 24 小时）。请提供新证书：",
    rotateOk: "轮换证书",
    rotated: "SP 证书已轮换",
    loadFailed: "无法读取 SAML SP",
    empty: "尚未注册 SAML Service Provider",
    previousUntil: "旧证书有效至 {time}",
    overlap: "证书重叠",
    edit: "编辑",
    rotate: "轮换证书",
    disableTitle: "停用 {name}？",
    disableHint: "停用后新的 SAML 登录请求将被拒绝。",
    disable: "停用",
    purge: "永久删除",
    editTitle: "编辑 SAML Service Provider",
    createTitle: "注册 SAML Service Provider",
    metadataHint: "可填写 Metadata URL/XML 自动导入，或手动填写下方必填字段",
    name: "名称",
    mapping: "属性映射（JSON Object）",
    cert: "X.509 证书",
    enable: "启用 Service Provider",
    save: "保存 Service Provider",
    verify: "验证并注册",
    purgeTitle: "永久删除 SAML Service Provider",
    irreversible: "此操作无法撤销",
    purgeHint: "Service Provider 配置及其 SAML Session 将被物理删除，相关应用将无法继续使用 SAML 登录。",
    purgeLead: "请输入服务名称 ",
    purgeTail: " 以确认：",
  },
  oidc: {
    eyebrow: "协议接入",
    title: "OIDC / OAuth Client",
    description: "管理回调地址、范围、PKCE、PAR、CIBA、JAR、mTLS、Client Secret 重叠轮换，以及应用所有者。",
    register: "注册 Client",
    registeredTitle: "Client 已注册",
    secretOnce: "Client Secret 只显示一次",
    updated: "OIDC Client 已更新",
    updateFailed: "更新失败",
    registerFailed: "注册失败",
    rotateTitle: "轮换 {name} 的 Client Secret？",
    rotateHint: "将签发新 Secret；旧 Secret 默认仍有效 24 小时，便于应用平滑切换。新 Secret 只显示一次。",
    rotateOk: "轮换 Secret",
    rotatedTitle: "Client Secret 已轮换",
    newSecretOnce: "新 Client Secret 只显示一次",
    previousUntil: "旧 Secret 有效至 {time}",
    newSecret: "新 Client Secret",
    secretSaved: "我已保存",
    rotateFailed: "轮换失败",
    retireTitle: "立即失效旧 Secret？",
    retireHint: "重叠窗口将结束，仅新 Secret 可继续调用 token/introspect/revoke。依赖旧 Secret 的应用会立即失败。",
    retireOk: "失效旧 Secret",
    retired: "旧 Secret 已失效",
    actionFailed: "操作失败",
    purged: "OIDC Client 已永久删除",
    purgeFailed: "永久删除失败",
    loadFailed: "OAuth Client 管理接口不可用",
    empty: "尚未注册 OIDC Client",
    previousSecretUntil: "旧 Secret 有效至 {time}",
    lastRotated: "上次轮换 {time}",
    overlapping: "重叠中",
    statusEnabled: "启用",
    statusPaused: "已停用",
    pausedEyebrow: "应用状态",
    pausedSeal: "已停用",
    pausedTitle: "这个应用已停用",
    pausedLead: "{name} 暂时不能用来登录。这是管理员停用了应用，不是你的账号出错。",
    pausedClient: "应用标识",
    pausedBack: "回到工作区",
    pausedMissing: "这个应用",
    enableStepTitle: "启用应用",
    disableStepTitle: "停用应用",
    enableStepHint: "启用后，用户可以再次通过 {name} 登录。请先完成二级确认。",
    disableStepHint: "停用后，用户打开 {name} 时会看到已停用说明，不能继续登录。请先完成二级确认。",
    activitySaved: "应用状态已更新",
    owner: "所有者",
    ownerNone: "未指定",
    transfer: "转移所有者",
    transferTitle: "转移 {name} 的所有者",
    transferLead: "新所有者必须是本工作区里已经有 OIDC 开发者权限的用户。转移后，开发者控制台和这个应用的工单改由新所有者处理。",
    transferCurrent: "当前所有者",
    transferPick: "选择新所有者",
    transferEmpty: "这个工作区还没有其他可接收的开发者。",
    transferOk: "转移所有者",
    transferSaved: "所有者已转移",
    transferUnchanged: "所有者没有变化",
    transferFailed: "没能转移所有者",
    candidatesFailed: "没能读取开发者名单",
    ownerNotDeveloper: "只能转移给本工作区已有开发者权限的用户",
    ownerIneligible: "这个开发者账号当前不能接收应用",
    ownerChanged: "所有者刚刚变了，请刷新后再试",
    edit: "编辑",
    rotate: "轮换 Secret",
    retire: "失效旧 Secret",
    purge: "永久删除",
    editTitle: "编辑 OIDC Client",
    createTitle: "注册 OIDC Client",
    appName: "应用名称",
    descriptionField: "描述",
    homepage: "应用主页",
    logoUrl: "Logo 地址",
    logoUpload: "上传 Logo",
    logoHint: "PNG、JPEG 或 WEBP。也可以填写 https 地址。两者都有时，需要选择优先显示哪一个。",
    logoUploaded: "已保存上传的图片。网址仍会保留。",
    logoHeldUrl: "当前网址",
    logoHeldUpload: "已上传的图片",
    logoFormatTitle: "不能使用这个 Logo",
    logoFormatBody: "只接受 PNG、JPEG 或 WEBP。请换一个文件后再上传。",
    logoUploadOk: "Logo 已上传",
    logoUploadFailed: "Logo 没有上传",
    logoChoiceTitle: "这个应用有两个 Logo",
    logoChoiceLead: "请选择优先显示哪一个。也可以开启失败降级：任意一个资源不可用时，自动改用另一个。",
    logoChoiceUrl: "优先使用网址",
    logoChoiceUpload: "优先使用上传的图片",
    logoChoiceUploadHint: "平台里保存的图片",
    logoChoiceFallback: "开启失败降级",
    logoChoiceFallbackHint: "任意一个资源不可用时，自动改用另一个。",
    logoChoiceSave: "保存选择",
    logoChoiceLater: "稍后决定",
    logoChoiceSaved: "Logo 优先级已保存",
    logoChoiceFailed: "没能保存 Logo 优先级",
    logoChoiceEdit: "更改 Logo 优先级",
    grantTypes: "授权类型",
    homepageExtra: "门户「可用应用」的打开链接使用这个地址。留空则不提供跳转。",
    homepageInvalid: "请填写以 http:// 或 https:// 开头的完整地址",
    redirects: "Redirect URI（每行一个）",
    logoutRedirects: "退出后 Redirect URI（每行一个）",
    scopes: "允许的 Scope（空格分隔）",
    authMethod: "令牌端点认证方式",
    subjectDn: "证书主体名（Subject DN）",
    subjectRequired: "证书认证需要登记 Subject DN",
    accessTtl: "Access Token TTL（秒）",
    refreshTtl: "Refresh Token TTL（秒）",
    publicClient: "Public Client",
    forcePkce: "强制证明密钥交换",
    forcePar: "强制推送授权",
    forceMfa: "强制 MFA",
    sessionMode: "登录占用",
    sessionMulti: "允许多设备同时登录",
    sessionSingle: "仅限单设备，新登录挤下线",
    sessionModeExtra: "默认不影响其他应用。选择单设备后，此应用的新登录会使它自己的其他设备退出，并留下挤下线提醒。",
    singleSession: "单设备",
    ciba: "后台认证投递",
    cibaPoll: "poll（客户端轮询 /token）",
    cibaPing: "ping（OP 通知 auth_req_id）",
    cibaPush: "push（OP 推送令牌）",
    cibaUrl: "CIBA 通知 URL（HTTPS）",
    cibaUrlRequired: "ping/push 模式需要 HTTPS 通知端点",
    cibaUrlExtra: "ping 仅 POST auth_req_id；push 会 POST 令牌或错误。须公网 HTTPS，禁止 localhost。",
    jar: "签名授权公钥集",
    jarExtra: "登记 RS256/ES256 公钥后可用于签名授权请求。每把密钥必须有 kid。",
    enable: "启用 Client",
    save: "保存 Client",
    registerGenerate: "注册并生成凭据",
    purgeTitle: "永久删除 OIDC Client",
    irreversible: "此操作无法撤销",
    purgeHint: "授权码、Consent、Token 记录和 Refresh Session 将一并删除；已部署应用会立即失去刷新和重新授权能力。",
    purgeLead: "请输入应用名称 ",
    purgeTail: " 以确认：",
  },
  federation: {
    eyebrow: "联邦登录",
    title: "外部身份源",
    description: "配置 Google、GitHub、Microsoft、Apple、OIDC/Okta 等登录源。密钥加密存储；OIDC/Okta 可仅填 Issuer 自动发现端点。",
    add: "添加身份源",
    saved: "联邦 Provider 已保存（密钥已加密存储）",
    saveFailed: "保存失败",
    deleteTitle: "删除联邦身份源？",
    deleteHint: "该身份源将立即从租户登录选项中移除。已关联账号不会自动解绑，但无法再通过此源登录。",
    deleteOk: "删除身份源",
    deleted: "已删除身份源",
    validated: "校验通过",
    validateFailed: "校验失败",
    loadFailed: "无法读取联邦配置",
    empty: "尚未配置联邦登录",
    status: "状态",
    enabled: "启用",
    disabled: "停用",
    actions: "操作",
    validate: "校验",
    delete: "删除",
    modalTitle: "配置联邦 Provider",
    type: "类型",
    emailDomains: "邮箱域",
    emailDomainsHint: "每行一个域名，例如 acme.com。登录页只匹配完整域名，不会猜测上级域。",
    domains: "邮箱域",
    oidcGeneric: "通用 OIDC（可 Discovery）",
    okta: "Okta / 企业 OIDC 模板",
    appleSecret: "Private Key (.p8 PEM)",
    redirect: "Redirect URI（可选，默认使用门户回调）",
    entra: "Entra 租户（可选，默认 common）",
    entraTip: "可填 common / organizations / 或 Directory (tenant) ID",
    issuer: "Issuer URL",
    issuerExtra: "若未填 authorize/token/userinfo，将自动拉取 /.well-known/openid-configuration。",
    issuerRequired: "OIDC/Okta 需要 Issuer",
    teamId: "Team ID",
    teamTip: "Apple Developer Team ID",
    keyId: "Key ID",
    keyTip: "Sign in with Apple Key ID（存储在 authorize_url 字段）",
    scopesOptional: "Scopes（可选）",
    issuerOptional: "Issuer（可选）",
    enable: "启用",
    save: "保存",
  },
  protocolUi: {
    issuingRegion: "发行区域",
    issuingRegionHint: "会话创建时写入的区域标签；跨区刷新会被拒绝。",
    requestUri: "授权请求引用",
    requestUriHint: "PAR 返回的 request_uri，用于代替在地址栏暴露全部授权参数。",
    par: "推送授权（PAR）",
    parHint: "先把授权参数推到服务器，再带引用打开登录页，减少浏览器地址栏泄露。",
    pkce: "证明密钥交换（PKCE）",
    mTLS: "证书双向认证（mTLS）",
    mTLSHint: "用客户端 TLS 证书代替共享 Secret；Subject DN 须与边缘代理一致。",
    ciba: "后台认证（CIBA）",
    jar: "签名授权请求（JAR）",
    jwks: "公钥集（JWKS）",
    issuerPar: "Issuer PAR",
  },
  helpers: {
    jsonObject: "请输入 JSON Object",
    jsonInvalid: "请输入有效的 JSON Object",
    jwksShape: "JWKS 必须是含 keys 数组的 JSON Object",
    jwksInvalid: "请输入有效的 JWKS JSON",
  },
  apiErrors: {
    fallback: "操作失败",
    csrf: "安全令牌已失效，请刷新页面后重试",
    upstream: "身份服务暂时不可用，请稍后重试",
    timeout: "请求超时，请稍后重试",
    network: "网络连接失败，请检查后重试",
    maintenance: "身份服务正在维护，请稍后再试",
  },
  sources: {
    ldap: "企业 LDAP",
    unknownProvider: "未知身份源",
    oidcApp: "OIDC 应用 · {id}",
    federation: "第三方身份 · {name}",
    password: "密码登录",
    unknown: "未知来源",
  },
  recovery: {
    confirmTitle: "确认验证邮箱",
    confirmHint: "打开链接不会自动完成验证。请确认这是你本人操作后再继续。",
    confirmVerify: "确认验证这个邮箱",
    verifying: "正在验证邮箱",
    verifyingHint: "请稍候，我们正在检查一次性验证链接。",
    verified: "邮箱验证完成",
    verifiedHint: "现在可以使用已验证的邮箱继续登录。",
    backLogin: "返回登录",
    linkInvalid: "验证链接无效或已过期",
    linkInvalidHint: "请登录后重新发送验证邮件。",
    resetMissing: "重置链接缺少必要参数",
    resetFailed: "密码重置失败",
    updated: "密码已更新",
    updatedHint: "所有旧登录会话均已退出，请使用新密码登录。",
    goLogin: "前往登录",
    eyebrow: "账号恢复",
    resetTitle: "设置新密码",
    resetIntro: "新密码生效后，其他设备上的登录状态将立即失效。",
    newPassword: "新密码",
    passwordMin: "密码至少需要 8 个字符",
    confirmPassword: "确认新密码",
    confirmRequired: "请再次输入新密码",
    mismatch: "两次输入的密码不一致",
    update: "更新密码",
    inviteMissing: "邀请链接缺少必要参数",
    inviteInvalid: "邀请无效或已过期",
    acceptFailed: "接受邀请失败",
    inviteUnavailable: "邀请不可用",
    reading: "正在读取邀请",
    wait: "请稍候。",
    joined: "已加入工作区",
    joinedHint: "账号 {email} 已创建，请使用新密码登录。",
    inviteEyebrow: "成员邀请",
    acceptTitle: "接受邀请",
    acceptLead: "你被邀请加入 ",
    roleAdmin: "租户管理员",
    roleMember: "普通成员",
    acceptMid: "。邮箱 ",
    acceptTail: " 将作为登录标识。",
    acceptUntil: " 邀请有效至 {time}。",
    username: "用户名",
    usernameMin: "用户名至少 3 个字符",
    displayName: "显示名称",
    setPassword: "设置密码",
    passwordMinShort: "密码至少 8 个字符",
    confirmShort: "确认密码",
    confirmAgain: "请再次输入密码",
    createJoin: "创建账号并加入",
    thesis: "安全恢复你的身份访问。",
    thesisBody: "一次性链接、密码策略与全会话撤销共同保护账号恢复过程。",
  },
  setup: {
    connect: "连接服务",
    domains: "访问域名",
    admin: "顶级管理员",
    confirm: "确认启用",
    restartTitle: "初始化完成，需要重启服务",
    restartBody: "运行 ./manage.sh restart applications 载入加密安装配置，然后打开登录页面。",
    gotIt: "我知道了",
    initialized: "OwO! Identity 已初始化",
    already: "系统已完成初始化，正在转到登录页面",
    failed: "初始化失败",
    badge: "首次部署向导",
    thesis: "建立可信的身份基础。",
    thesisBody: "所有连接会在保存前验证。初始化完成后，此入口将永久关闭。",
    step: "步骤 {current} / {total}",
    connectTitle: "连接持久化服务",
    connectHint: "配置 PostgreSQL 与 Redis。凭据将加密保存，不会写入版本库。",
    redisAddr: "Redis 地址",
    redisPassword: "Redis 密码",
    boundaryTitle: "定义可信访问边界",
    boundaryHint: "这些域名将用于门户、OIDC 回调、SAML ACS 和 CORS 校验。",
    externalUrl: "外部服务 URL",
    adminHost: "平台管理域名",
    origins: "允许的域名与 Origin",
    adminTitle: "创建顶级管理员",
    adminHint: "该账号拥有全平台权限。密码最少 12 位。",
    tenantName: "主租户名称",
    username: "用户名",
    displayName: "显示名称",
    email: "邮箱",
    password: "密码",
    enableTitle: "验证并启用",
    enableHint: "系统将测试连接、执行数据库迁移并创建顶级管理员。",
    once: "初始化是一次性操作",
    onceHint: "完成后 /setup 将与不存在的地址一样返回 404。基础连接配置的后续修改需要超级管理员权限并重启服务。",
    checkStores: "PostgreSQL 与 Redis 配置已填写",
    checkDomains: "可信域名边界已定义",
    checkAdmin: "顶级管理员信息已确认",
    confirmLabel: "我确认启用 OwO! Identity",
    confirmRequired: "请确认初始化操作",
    confirmed: "已确认",
    unconfirmed: "未确认",
    back: "上一步",
    next: "继续",
    finish: "验证并初始化",
    unreachable: "无法连接初始化服务",
  },
  docs: {
    eyebrow: "对接",
    title: "对接文档",
    description: "按你能使用的区域查看账号、协议、租户和平台说明。",
    nav: "文档目录",
    issuer: "当前工作区 Issuer",
    copy: "复制",
    copied: "已复制",
    method: "方法",
    path: "路径",
    auth: "认证",
    params: "参数",
    param: "名称",
    where: "位置",
    required: "必填",
    detail: "说明",
    yes: "是",
    no: "否",
    request: "请求示例",
    responses: "响应示例",
    successZone: "成功响应",
    failureZone: "失败响应",
  },
  develop: {
    title: "申请成为 {tenant} 的 OIDC 应用开发者",
    lead: "通过后，你可以注册并管理自己创建的公开 OIDC 应用。不能管理别人的应用，也不能改工作区安全策略。",
    register: "注册并申请",
    login: "登录已有账号",
    loginExisting: "登录已有账号",
    closedTitle: "此工作区未开放注册",
    closedBody: "公开注册已关闭。已有账号仍可登录后再申请。邀请入驻不受此开关影响。",
    otherWorkspace: "你当前登录的是 {current}。要申请这个工作区，请登录或注册该工作区的账号。",
    missing: "找不到这个工作区。",
    policyFailed: "暂时读不到工作区的注册状态",
    loadFailed: "暂时读不到申请状态",
    already: "你已是这个工作区的 OIDC 应用开发者。",
    openConsole: "打开开发者控制台",
    pending: "申请正在等待租户管理员处理。",
    ineligible: "当前账号不能申请。请先完成邮箱验证，并确认账号未被停用或封禁。",
    statement: "说明你要接入的应用",
    submit: "提交申请",
    submitReview: "提交审核",
    submittedReview: "已提交审核",
    pendingTitle: "待审核的应用",
    approvedTitle: "已通过的应用",
    noRequests: "还没有待审核的应用。",
    clientReviewTitle: "OIDC 应用审核",
    noClientReviews: "还没有应用创建申请。",
    secretOnce: "客户端密钥只显示这一次。审核通过前，这个应用不能使用。",
    consoleEyebrow: "开发者",
    consoleTitle: "我的 OIDC 应用",
    consoleLead: "创建申请要等租户管理员或平台管理员通过。通过之前，相关请求会被拒绝。",
    create: "创建应用",
    created: "已创建",
    save: "保存",
    saved: "已保存",
    saveFailed: "没有保存应用",
    clientsFailed: "暂时读不到应用",
    clientsEmpty: "还没有你创建的应用。",
    client: "应用",
    oid: "OID",
    platformCheck: "平台校验",
    platformVerified: "是",
    state: "状态",
    active: "启用",
    paused: "已停用",
    actions: "操作",
    edit: "编辑",
    clientName: "名称",
    clientDescription: "说明",
    homepage: "主页",
    redirects: "回调地址",
    redirectsHint: "每行一个。公网地址使用 https，本机可用 http://localhost。",
    enabled: "启用",
    queueEyebrow: "申请",
    queueTitle: "开发者申请",
    queueLead: "把申请链接发给要接入的人。通过后对方只能管理自己创建的应用。",
    copyLink: "复制申请链接",
    linkCopied: "已复制",
    linkFailed: "没有复制链接",
    queueFailed: "暂时读不到申请",
    queueEmpty: "还没有申请。",
    applicant: "申请人",
    submittedAt: "提交时间",
    approve: "通过",
    approved: "已通过",
    reject: "拒绝",
    rejected: "已拒绝",
    revoke: "收回",
    revoked: "已收回",
    decideFailed: "没有完成处理",
    reason: "写下原因",
    statusPending: "待审",
    statusApproved: "已通过",
    statusRejected: "已拒绝",
    statusRevoked: "已收回",
  },
  dossier: {
    eyebrow: "超级视角",
    title: "用户档案",
    lead: "查看各工作区用户的授权、设备和审计。档案只读。占用大小是估算，不是账单。",
    search: "用户名、邮箱或显示名",
    tenant: "工作区标识",
    anyStatus: "全部状态",
    loadFailed: "暂时读不到用户",
    empty: "没有匹配的用户。",
    detailFailed: "暂时读不到档案",
    pick: "选择一行查看档案。",
    person: "用户",
    workspace: "工作区",
    state: "状态",
    lastLogin: "上次登录",
    email: "邮箱",
    roles: "角色",
    apps: "已授权应用",
    devices: "登录设备",
    footprint: "估算占用",
    estimate: "约 {size}",
    groups: "分组",
    mfa: "第二步验证",
    federation: "联邦身份",
    audit: "审计",
    sameEmail: "其他工作区",
    parts: "占用构成",
    manage: "在该工作区管理",
    back: "返回列表",
    more: "还有 {count} 项",
    exact: "{bytes} 字节",
    none: "无",
    status: {
      active: "启用",
      inactive: "停用",
      banned: "封禁",
      locked: "锁定",
      pending_deletion: "待删除",
    },
    part: {
      profile: "资料",
      emails: "邮箱",
      addresses: "地址",
      sessions: "会话",
      consents: "授权",
      audits: "审计",
      federations: "联邦",
      webauthn: "通行密钥",
      backup_codes: "备用码",
      invitations: "邀请",
      owned_clients: "名下应用",
    },
  },
  load: {
    count: "倍数",
    unit: "单位",
    closer: "拉近到 1 分钟",
    failed: "无法读取负载",
    empty: "这段时间没有请求",
    requests: "请求数",
    bytesIn: "入站字节",
    bytesOut: "出站字节",
    errors: "错误",
    latency: "平均延迟",
    latencyValue: "{count} 毫秒",
    warnRequest: "警告",
    errorRequest: "错误",
    when: "时间",
    route: "路由",
    status: "状态",
    source: "产生源",
    sourceTitle: "请求产生源",
    detailExpired: "这个窗口早于 72 小时，只能看到聚合，看不到单条请求。",
    units: { second: "秒", minute: "分钟", hour: "小时", day: "天", month: "月" },
  },
  assets: {
    eyebrow: "资产",
    title: "占用与数据",
    description: "查看进程、缓存和白名单表。可以释放运行时缓存，也可以删除运行日志和不再引用的文件。",
    refresh: "刷新",
    usageHint: "这里显示进程和数据存储占用，不是整机网卡或磁盘。",
    usageFailed: "无法读取占用",
    heap: "堆内存",
    goroutines: "Goroutine",
    redisMemory: "Redis 内存",
    assetBytes: "上传文件",
    table: "数据表",
    viewUsage: "占用",
    viewTables: "数据表",
    viewCache: "运行缓存",
    viewReclaim: "清理占用",
    viewLogo: "Logo 上限",
    viewBackup: "数据备份",
    backup: {
      title: "定期备份",
      hint: "按间隔自动打包数据库、上传文件和签名密钥。超过槽位或超过有效期的备份会自动删除。Redis、安装密钥和解密密码不在包里。",
      failed: "无法读取备份",
      empty: "还没有备份。保存解密密码后可以立即备份，或等自动备份开始。",
      auto: "自动备份",
      interval: "备份间隔",
      slots: "最大槽位",
      retention: "每份有效期",
      password: "解密密码",
      passwordHint: "至少 12 个字符。自动备份会用它加密，下载时还要再输入一次。",
      passwordKeep: "留空则继续使用当前解密密码。填写则会更换，已有备份仍用当时的密码。",
      hourSuffix: "小时",
      hours: "{count} 小时",
      days: "{count} 天",
      retentionGap: "有效期短于备份间隔。下一份生成前，上一份可能已经过期。",
      save: "保存设置",
      run: "立即备份",
      running: "正在写入一份备份。",
      magazine: "备份槽位",
      slot: "槽位 {index}",
      slotEmpty: "空槽",
      slotReady: "可下载",
      slotRunning: "正在写入",
      slotFailed: "失败",
      trigger: "来源",
      triggerSchedule: "自动",
      triggerManual: "手动",
      created: "生成时间",
      expires: "失效时间",
      pending: "完成后计算",
      size: "占用",
      contentsLabel: "内容",
      contents: "{tables} 张表 · {files} 个文件 · {keys} 把签名密钥",
      keySet: "设于 {time}",
      sha: "校验",
      download: "下载备份",
      extras: "还有 {count} 份没有放进当前槽位。",
      policyTitle: "保存备份设置",
      policyBody: "写明原因，并输入二级密码。确认后才会改间隔、槽位、有效期或解密密码。",
      downloadTitle: "下载备份",
      downloadBody: "输入这份备份当时的解密密码，以及你的二级密码。密码不对不会消耗二级确认。",
      decrypt: "解密密码",
      remove: "删除备份",
      removeTitle: "删除备份",
      removeBody: "写明原因，并输入二级密码。确认后会删除这份备份。",
      deleted: "备份已删除",
      confirm: "确认执行",
      saved: "备份设置已保存",
      started: "备份已开始",
      downloaded: "备份已下载",
      mismatch: "解密密码与这份备份不一致",
      locked: "解密密码尝试过多，请稍后再试",
      inProgress: "已有一份备份正在写入",
      noPassword: "先设置解密密码",
      notify: "邮件通知",
      notifyHint: "打开后设定周期。到点时，给已验证邮箱的超级管理员发信，汇总这个周期里的备份下载和更新。没有这类变化时不发信。",
      notifyInterval: "通知周期",
    },
    noSql: "数据表来自当前数据库。密钥列不会显示。只能修改已经标出的列，不能执行 SQL。",
    search: "搜索当前表",
    tenantFilter: "租户 ID",
    rows: "{count} 行",
    readOnly: "只读",
    canEdit: "可修改标出的列",
    canRevoke: "只能撤销，不能改字段",
    columns: "可见列",
    yes: "是",
    no: "否",
    record: "记录",
    revoke: "撤销",
    deleteRow: "删除",
    fieldHint: "只列出这张表允许修改的列。",
    assetTables: {
      _ops_drill_marker: "运维演练标记",
      access_review_items: "访问评审条目",
      access_reviews: "访问评审",
      announcement_reads: "公告已读记录",
      announcements: "公告",
      audit_archive_batches: "审计归档批次",
      audit_logs: "租户审计",
      audit_outbox: "审计投递队列",
      authorization_codes: "OIDC 授权码",
      authorization_interactions: "登录同意的一次性票据，不保存原始令牌",
      backup_codes: "备用恢复码",
      bulk_operation_logs: "批量操作记录",
      ciba_auth_requests: "CIBA 认证请求",
      developer_applications: "开发者申请",
      developer_client_requests: "开发者应用申请",
      device_codes: "设备码",
      email_templates: "邮件模板",
      external_identities: "外部身份绑定",
      federation_providers: "联邦登录提供方",
      goose_db_version: "架构迁移版本",
      group_members: "用户组成员",
      group_roles: "用户组权限组",
      groups: "用户组",
      ip_rules: "IP 访问规则",
      legal_acceptances: "法律文件阅读登记",
      legal_document_versions: "法律文件版本",
      legal_documents: "法律文件",
      legal_notice_deliveries: "法律通知投递",
      legal_read_deferrals: "法律阅读延后",
      mfa_challenges: "多因素登录挑战",
      oauth_client_verifications: "应用人工校验",
      oauth_clients: "OIDC 应用",
      oauth_tokens: "已签发令牌",
      password_history: "历史密码",
      password_reset_tokens: "密码重置票据",
      permissions: "权限目录",
      platform_assets: "上传文件",
      platform_audit_logs: "平台审计",
      platform_logs: "运行日志",
      platform_maintenance: "维护模式",
      platform_notice_policy: "通知策略",
      platform_backup_policy: "全平台备份计划",
      platform_backup_keys: "备份解密密钥",
      platform_backups: "全平台备份",
      payment_bills: "支付账单",
      payment_consents: "支付授权",
      payment_fee_profile_overrides: "支付手续费档位覆盖",
      payment_invoices: "支付发票",
      payment_methods: "支付方式",
      payment_stripe_configs: "Stripe 支付配置",
      payment_stripe_keys: "Stripe 密钥",
      withdrawal_requests: "提现申请",
      pushed_authorization_requests: "推送授权请求",
      risk_signals: "登录风险信号",
      role_permissions: "权限组权限",
      roles: "权限组",
      saml_service_providers: "SAML 服务方",
      saml_sessions: "SAML 会话",
      security_notices: "安全通知",
      sessions: "登录会话",
      support_idempotency: "工单幂等记录",
      support_notifications: "工单通知",
      support_ticket_feedback: "工单反馈",
      support_ticket_handlers: "工单处理人",
      support_ticket_messages: "工单消息",
      support_tickets: "工单",
      tenants: "租户",
      traffic_buckets: "流量汇总",
      traffic_samples: "流量样本",
      user_addresses: "通讯地址",
      user_consents: "应用授权",
      user_emails: "备用邮箱",
      user_invitations: "邀请",
      user_preferences: "账号偏好",
      user_profiles: "个人资料",
      user_roles: "直接授予的权限组",
      user_step_up_credentials: "二级确认凭据",
      users: "用户",
      verification_tokens: "邮箱验证票据",
      webauthn_credentials: "通行密钥",
    },
    clearLogs: "清理近 24 小时运行日志",
    failed: "无法读取资产",
    empty: "没有可显示的行",
    summary: "摘要",
    when: "时间",
    actions: "操作",
    change: "修改",
    remove: "删除或撤销",
    cacheTitle: "运行缓存",
    cacheHint: "按前缀清理。登录锁和黑名单也在这里，释放运行时缓存时不会动它们。",
    keys: "{count} 个键",
    clearCache: "清理",
    reclaimTitle: "运行时占用",
    reclaimHint: "释放缓存不会删除审计。删除日志和文件前要选择范围，并输入二级密码。",
    reclaimFailed: "无法读取可清理的占用",
    reclaimEmpty: "没有可清理的运行时占用",
    reclaimReading: "{count} 项 · {size}",
    reclaimSizeUnknown: "大小未统计",
    releaseCache: "运行时缓存",
    releaseCacheHint: "归还进程堆，并清掉地址定位缓存和未使用的二级确认令牌。",
    release: "释放",
    reclaimLogs: "运行日志",
    reclaimLogsHint: "只删除平台自己的运行日志。审计记录留在审计清理里。",
    deleteLogs: "删除日志",
    reclaimFiles: "无人引用的文件",
    reclaimFilesHint: "只删除上传目录里已经没有记录的 Logo 文件。",
    deleteFiles: "删除文件",
    horizon: "删除范围",
    horizon24: "早于 24 小时",
    horizon7: "早于 7 天",
    horizonAll: "全部运行日志",
    cacheReleased: "运行时缓存已释放",
    filesCleared: "无人引用的文件已删除",
    logoLimits: "Logo 上限",
    maxBytes: "最大体积",
    maxEdge: "最长边",
    byteSuffix: "字节",
    pixelSuffix: "像素",
    edgeReading: "{count} 像素",
    saveLimits: "保存上限",
    limitsSaved: "Logo 上限已保存",
    confirmTitle: "确认风险操作",
    confirmBody: "写明原因，并输入二级密码。确认后会作用到所选对象并写入平台审计。",
    field: "字段",
    value: "新值",
    reason: "原因",
    confirm: "确认执行",
    updated: "已更新",
    deleted: "已删除",
    cacheCleared: "缓存已清理",
    logsCleared: "运行日志已清理",
  },
  stepUp: {
    title: "二级密码",
    hint: "租户管理员和平台超级管理员用它确认风险操作，例如修改数据表、清理缓存、清理运行日志和清理审计。它不能与登录密码相同。已启用的两步验证也可以代替它。",
    rail: "二级",
    confirmHint: "输入二级密码。已绑定的验证器可以完成同一次确认。",
    configured: "已设置二级密码",
    missing: "尚未设置二级密码",
    methods: "两步验证 {totp}，通行密钥 {passkey}",
    on: "已启用",
    off: "未启用",
    loginPassword: "当前登录密码",
    newPassword: "新的二级密码",
    different: "不能与登录密码相同",
    save: "保存二级密码",
    clear: "清除二级密码",
    saved: "二级密码已保存",
    cleared: "二级密码已清除",
    failed: "二级密码操作失败",
    password: "二级密码",
    totp: "两步验证",
    method: "确认方式",
    code: "密码或验证码",
    passkeyHint: "也可以用已注册的通行密钥完成同一次确认。",
    usePasskey: "使用通行密钥",
    passkeyFailed: "通行密钥确认没有完成。请确认这台设备已经注册通行密钥，然后重试。",
  },
  geo: {
    locate: "定位",
    ip: "IP",
    private: "私网地址",
    unavailable: "本地地址库不可用",
    unknown: "没有位置记录",
    failed: "定位失败",
  },
  compose: {
    minimize: "最小化",
    expand: "全屏",
    restore: "还原",
    close: "关闭",
  },
  support: {
    eyebrow: "服务台",
    title: "工单",
    description: "任意租户账号都可以向平台提交工单，并在这里继续对话。",
    mine: "我的工单",
    queue: "待处理队列",
    empty: "还没有工单",
    missing: "找不到这张工单",
    created: "工单已提交",
    failed: "工单操作失败",
    create: "提交工单",
    openComposer: "创建工单",
    sectionCompose: "提交新工单",
    sectionThread: "对话",
    sectionActions: "处理",
    sectionFeedback: "反馈记录",
    scope: "对象",
    scopePlatform: "全平台",
    scopeTenant: "本租户",
    scopeApp: "某个 OIDC 应用",
    scopeValue: { platform: "全平台", tenant: "本租户", oidc_client: "OIDC 应用" },
    source: "来源",
    portalSource: "门户",
    targetApp: "相关应用",
    category: "分类",
    categoryValue: { sign_in: "登录", account: "账号", mfa: "MFA", application: "应用", other: "其他" },
    ticketTitle: "标题",
    body: "首次原因",
    requester: "提交人",
    tenant: "所属租户",
    opened: "提交时间",
    firstResponse: "首次回复",
    closed: "关闭时间",
    handlers: "处理人",
    unassigned: "尚未指派",
    inactive: "（已失效）",
    reply: "回复",
    send: "发送",
    internal: "内部备注",
    reason: "原因（至少 8 个字符）",
    feedback: "提交反馈",
    feedbackSaved: "反馈已保存",
    satisfaction: "是否满意",
    resolved: "是否已处理",
    resolvedValue: { yes: "已解决", partial: "部分解决", no: "未解决" },
    service: "客服评价",
    comment: "评语",
    status: { submitted: "已提交", reviewed: "已审阅", in_progress: "处理中", pending_feedback: "待反馈", closed: "已关闭" },
  },
  announcements: {
    eyebrow: "平台动态",
    title: "公告",
    description: "超级管理员编写公告，并在发布时选择哪些身份可以看到。",
    detailDescription: "公告详情和阅读情况",
    backToList: "返回公告列表",
    empty: "没有要阅读的公告",
    saved: "公告已保存",
    failed: "公告操作失败",
    itemTitle: "标题",
    body: "正文",
    severity: "严重程度",
    severityValue: { info: "信息", warning: "警告", critical: "严重" },
    audience: "受众",
    audienceValue: { tenant_admins: "租户管理员", oidc_developers: "OIDC 开发者", all_users: "全部已登录用户" },
    saveDraft: "保存草稿",
    sectionList: "公告列表",
    sectionCompose: "编写公告",
    sectionDetail: "公告正文",
    publisher: "发布者",
    attachments: "附件与图片",
    attachmentHint: "每个文件最大 50 MiB，最多 10 个。支持图片、PDF、音频和视频。",
    attachmentTooLarge: "单个附件不能超过 50 MiB",
    attachmentLimit: "一则公告最多添加 10 个附件",
    removeAttachment: "移除",
    previewImage: "查看大图：{name}",
    downloadAttachment: "下载 {name}",
    download: "下载",
    mediaUnsupported: "当前浏览器无法播放此媒体。",
    imageCount: "{count} 个附件",
    imageLabel: "图片 {count}",
    readReport: "受众阅读情况",
    readReportLoading: "正在读取阅读情况",
    readReportFailed: "无法读取公告阅读情况",
    readTotal: "总体已读 {read} / {total}",
    readCounts: "已读 {read} · 未读 {unread}",
    readRate: "已读率",
    statusValue: { published: "已发布", archived: "已归档" },
    renotifyAction: "重新通知未读用户",
    renotifyQueued: "已向 {count} 位未读受众重新排入通知",
    renotifyUnavailable: "此等级的 SMTP 发信事件未启用或 SMTP 尚未配置",
    publish: "发布",
    openComposer: "发布公告",
    archive: "归档",
    draft: "草稿",
    view: "查看",
    dismiss: "本次关闭",
    read: "已读",
    unread: "未读",
    unreadCount: "未读 {count} 条",
    confirmRead: "我已阅读",
    readConfirmed: "已确认阅读",
    later: "稍后阅读",
  },
  maintenance: {
    eyebrow: "可用性",
    title: "维护模式",
    description: "开启后默认只允许超级管理员登录。可以按 API 组临时放行。",
    on: "维护模式已开启",
    off: "维护模式已关闭",
    defaultHint: "未填写公开说明时，登录页使用默认提示。",
    never: "还没有变更记录",
    toggle: "维护模式开关",
    editGroups: "调整放行的 API",
    confirmTitle: "确认维护策略",
    publicMessage: "登录页说明",
    reason: "原因",
    groups: "放行的 API 组",
    probeWarning: "探活默认关闭。负载均衡可能因此把节点判为不健康。需要探活时请勾选。",
    save: "保存维护策略",
    saved: "维护策略已保存",
    failed: "维护策略没有保存",
    holdTitle: "身份服务正在维护",
    holdHint: "你的登录会话仍然保留。维护结束后可以继续使用。",
    group: {
      probes: "探活与指标",
      discovery: "发现与 JWKS",
      oidc: "OIDC",
      saml: "SAML",
      scim: "SCIM",
      federation: "联邦登录",
      auth_public: "注册与找回密码",
      portal: "已登录用户门户",
      tenant_admin: "租户管理",
      developer: "开发者",
      platform: "平台控制台",
      assets: "公开 Logo 与头像",
    },
  },
  legal: {
    terms: "入驻须知",
    privacy: "数据保护声明",
    impressum: "Impressum",
    paymentPolicy: "支付政策",
    library: "说明文件",
    libraryHint: "集中查阅当前平台说明和本租户可见的文件。",
    thirdParty: "第三方应用",
    verified: "平台人工校验通过",
    grant: "授予人工校验",
    revoke: "撤销人工校验",
    reason: "原因",
    reasonHint: "至少 8 个字，说明这次验收依据。",
    verifySaved: "校验标记已更新",
    verifyFailed: "校验标记没有更新",
    agreeTerms: "我同意《入驻须知》版本 {version}",
    acknowledgePrivacy: "我已阅读《数据保护声明》版本 {version}。这不是对必需处理的同意。",
    agreeDeveloper: "我同意《{title}》版本 {version}",
    confirmTitle: "确认当前版本",
    confirmLead: "版本有更新。确认后才会进入工作区。",
    continue: "确认并继续",
    loading: "正在读取当前版本",
    reading: "正在打开文件",
    loadFailed: "文件没有打开",
    unavailable: "这份文件不存在，或已经下架。",
    signIn: "请先登录后再查阅这份文件",
    developerLead: "申请成为开发者之前，请读完并确认下面的须知。",
    confirmDeveloper: "确认开发者须知",
    registerRequired: "请先读完并勾选入驻须知和数据保护声明",
    deskEyebrow: "文件版本",
    deskTitle: "法律文件",
    deskHint: "发布后通知受影响的人。已发布的正文不能改，修改要另起一个版本。",
    body: "正文",
    changelog: "本次变更说明",
    saveDraft: "保存草稿",
    submit: "提交修改",
    publish: "发布",
    withdraw: "下架",
    saved: "已保存",
    saveFailed: "没有保存",
    readOnly: "这份文件当前只能阅读。本租户的租户管理员可以编辑；只持有平台管理员权限时可以查阅和下架，不能改写。",
    statusDraft: "草稿",
    statusSubmitted: "已提交",
    statusPublished: "已发布",
    statusWithdrawn: "已下架",
    platformTab: "法律文件",
    adminTab: "开发者须知",
    versionsTab: "版本",
    readsTab: "阅读登记",
    readsEyebrow: "阅读登记",
    readsTitle: "谁读过平台文件",
    readsHint: "只统计当前已发布版本。没有登记的人下次登录时会看到提示，直到确认阅读。晚点通知不会记为已读。",
    readsLoadFailed: "阅读登记没有打开",
    readsEmpty: "还没有已发布的平台文件",
    readCount: "已阅读 {count}",
    unreadCount: "未阅读 {count}",
    rosterEmpty: "这个筛选下没有人",
    filterAll: "全部",
    filterRead: "已阅读",
    filterUnread: "未阅读",
    readAt: "阅读时间",
    waiting: "未登记",
    reader: "用户",
    workspace: "工作区",
    promptTitle: "请确认你已阅读",
    promptLead: "这些平台文件还没有登记为已阅读。确认之前，每次登录都会再提示。",
    confirmRead: "我已阅读",
    markRead: "我已阅读",
    confirmReadItem: "我已阅读《{title}》版本 {version}",
    later: "晚点通知我",
    laterHint: "这次登录不再提示。下次登录仍会出现，直到你确认阅读。",
    promptFailed: "没有保存阅读登记",
    laterFailed: "这次没能延后提示",
    promptRetry: "重试",
  },
  errors: {
    boundaryTitle: "这个页面没有完成渲染",
    boundaryHint: "其余导航仍然可用。重试会重新挂载当前页面。",
    retry: "重试",
  },
} as const;
